'use strict';
/**
 * 赞美诗资料库 - 全局配置
 *
 * 部署前只需修改这一个文件！
 * 本地开发：API_BASE = 'http://localhost:8787'
 * 正式部署：API_BASE = 'https://hymns-worker.yangyang7920.workers.dev'
 */
/** API 基础 URL */
const API_BASE = 'https://hymns.solua.one';
/** 兼容旧版 API 变量名 */
const API = API_BASE;
/** 配置常量 */
const CONFIG = {
  PAGE_SIZE: 20,
  SEARCH_DEBOUNCE: 300,
  MAX_COMMENT_LENGTH: 2000,
  CHUNK_SIZE: 10 * 1024 * 1024,
  REQUEST_TIMEOUT: 15000,
  PLAYLIST_REFRESH: 300000,
};
/* ── 导出到全局 ── */
if (typeof window !== 'undefined') {
  window.API_BASE = API_BASE;
  window.API = API;
}
//# sourceMappingURL=config.js.map

'use strict';
/**
 * 赞美诗资料库 - 公共工具函数
 * 所有前端页面共享的工具函数库
 */
/* ════════════════════════════════
   工具函数
   ════════════════════════════════ */
/** HTML 内容转义 - 防止 XSS */
function escHtml(s) {
  return String(s || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
/** HTML 属性转义 - 防止 XSS */
function escAttr(s) {
  return String(s || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
/** 格式化文件大小（支持到 GB） */
function formatSize(b) {
  if (!b) return '';
  if (b < 1024) return `${b} B`;
  if (b < 1024 * 1024) return `${(b / 1024).toFixed(1)} KB`;
  if (b < 1024 * 1024 * 1024) return `${(b / 1024 / 1024).toFixed(1)} MB`;
  return `${(b / 1024 / 1024 / 1024).toFixed(2)} GB`;
}
/** 格式化日期 */
function formatDate(d) {
  if (!d) return '';
  return new Date(d).toLocaleDateString('zh-CN');
}
/** 格式化日期时间 */
function formatDateTime(d) {
  if (!d) return '';
  return new Date(d).toLocaleString('zh-CN');
}
/** 从 YouTube URL 提取 video ID */
function getYoutubeId(url) {
  if (!url) return null;
  var m = url.match(/[?&]v=([a-zA-Z0-9_-]{11})/);
  if (m) return m[1];
  m = url.match(/youtu\.be\/([a-zA-Z0-9_-]{11})/);
  if (m) return m[1];
  m = url.match(/\/shorts\/([a-zA-Z0-9_-]{11})/);
  if (m) return m[1];
  return null;
}
/** 获取 YouTube 缩略图 URL */
function getYoutubeThumb(url) {
  var id = getYoutubeId(url);
  if (!id) return null;
  return (typeof API_BASE !== 'undefined' ? API_BASE : '') + '/api/thumb/' + id;
}
/** 格式化时长（秒 → mm:ss 或 h:mm:ss） */
function fmtDur(seconds) {
  if (!seconds) return '';
  var s = Math.floor(seconds);
  var m = Math.floor(s / 60);
  var sec = s % 60;
  return m + ':' + String(sec).padStart(2, '0');
}
/** 登出：清除 localStorage 并跳转首页 */
function logout() {
  localStorage.clear();
  location.href = '/';
}
/** 检测文件类型 */
function detectFileType(file) {
  if (file.file_type) return file.file_type;
  const mime = file.mime_type || '';
  const name = (file.file_name || '').toLowerCase();
  if (mime.startsWith('audio') || /\.(mp3|m4a|ogg|wav|flac|aac)$/i.test(name)) return 'audio';
  if (mime.startsWith('video') || /\.(mp4|webm|avi|mov|mkv)$/i.test(name)) return 'video';
  if (mime.startsWith('image') || mime.includes('pdf') || /\.(png|jpg|jpeg|gif|svg|pdf)$/i.test(name)) return 'sheet';
  if (mime.includes('text') || /\.(txt|md|lrc)$/i.test(name)) return 'lyrics';
  return 'other';
}
/** 获取文件类型对应的图标 SVG */
function getFileTypeIcon(fileType) {
  const icons = {
    audio: `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 18V5l12-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="16" r="3"/></svg>`,
    video: `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2" ry="2"/></svg>`,
    sheet: `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>`,
    lyrics: `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>`,
    other: `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>`,
  };
  return icons[fileType] ?? icons.other;
}
/** 获取文件类型对应的中文标签 */
function getFileTypeLabel(fileType) {
  const map = {
    audio: '音频',
    video: '视频',
    sheet: '歌谱',
    lyrics: '歌词',
    other: '文件',
  };
  return map[fileType] || '文件';
}
/** 显示错误提示（Modal） */
function showError(title, message) {
  const errorEl = document.getElementById('errorModal');
  if (errorEl) {
    const titleEl = document.getElementById('errorTitle');
    const msgEl = document.getElementById('errorMsg');
    if (titleEl) titleEl.textContent = title;
    if (msgEl) msgEl.textContent = message;
    errorEl.style.display = 'flex';
  } else {
    alert(`${title}：${message}`);
  }
}
/** 隐藏错误提示 */
function hideError() {
  const errorEl = document.getElementById('errorModal');
  if (errorEl) errorEl.style.display = 'none';
}
/** 显示成功提示（Toast） */
function showSuccess(message) {
  showToast(message, 'success');
}
/** 显示错误提示（Toast） */
function showErrorToast(message) {
  showToast(message, 'error');
}
/** Toast 容器 - 单例，栈式显示多个 Toast */
let _toastContainer = null;
function _ensureToastContainer() {
  if (!_toastContainer || !document.body.contains(_toastContainer)) {
    _toastContainer = document.createElement('div');
    _toastContainer.className = 'toast-container';
    document.body.appendChild(_toastContainer);
  }
  return _toastContainer;
}

/** 显示 Toast 提示（支持 stacking，自动顶部分布） */
function showToast(message, type = 'info') {
  const container = _ensureToastContainer();
  const el = document.createElement('div');
  el.className = 'toast' + (type === 'error' ? ' toast-error' : '');
  el.textContent = message;
  container.appendChild(el);
  setTimeout(() => {
    el.classList.add('out');
    setTimeout(() => el.remove(), 200);
  }, 3000);
}
/**
 * 带 JWT 认证和 401 过期检测的 fetch 封装
 * 自动注入 Authorization: Bearer header，遇到 401 时弹出重新登录提示
 * 用法与 fetch() 完全一致（返回值也是 Response 对象）
 *
 * @param {string} url - 请求 URL
 * @param {object} options - fetch 选项（无需传 Authorization header，会自动添加）
 * @returns {Promise<Response>}
 *
 * @example
 * const res = await fetchAuth('/api/playlists');
 * const data = await res.json();
 */
async function fetchAuth(url, options = {}) {
  const jwt = localStorage.getItem('jwt');
  const adminToken = localStorage.getItem('admin_token');
  const headers = { ...(options.headers || {}) };
  if (jwt && !headers['Authorization']) {
    headers['Authorization'] = 'Bearer ' + jwt;
  }
  if (adminToken && !headers['X-Admin-Token']) {
    headers['X-Admin-Token'] = adminToken;
  }
  const res = await fetch(url, { ...options, headers });
  if (res.status === 401 && jwt) {
    showLoginExpired();
  }
  return res;
}

/** 安全的 fetch 包装器 - 统一错误处理 */
async function safeFetch(url, options = {}, timeout = 15000) {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), timeout);
  try {
    const res = await fetch(url, { ...options, signal: controller.signal });
    clearTimeout(timeoutId);
    if (!res.ok) {
      const errorData = await res.json().catch(() => ({}));
      const statusMap = {
        400: '请求参数错误',
        401: '登录已过期，请重新登录',
        403: '没有权限执行此操作',
        404: '请求的资源不存在',
        409: '数据冲突',
        429: '请求太频繁，请稍后再试',
        500: '服务器内部错误',
        502: '网关错误',
        503: '服务器维护中',
        504: '网关超时',
      };
      throw new Error(statusMap[res.status] || errorData.error || errorData.message || `HTTP ${res.status}`);
    }
    return await res.json();
  } catch (err) {
    clearTimeout(timeoutId);
    if (err instanceof DOMException && err.name === 'AbortError') {
      throw new Error('网络请求超时，请检查网络连接后重试');
    }
    const error = err;
    const msg =
      {
        'Failed to fetch': '无法连接服务器，请检查网络',
        NetworkError: '网络错误，请稍后重试',
        Timeout: '请求超时，请检查网络',
        AbortError: '请求超时，请检查网络',
      }[error.name] ||
      {
        'Failed to fetch': '无法连接服务器，请检查网络',
        NetworkError: '网络错误，请稍后重试',
        Timeout: '请求超时，请检查网络',
        AbortError: '请求超时，请检查网络',
      }[error.message] ||
      error.message ||
      '操作失败';
    console.error('API 请求错误:', { url, error: error.message, status: error.name });
    throw new Error(msg);
  }
}
/** 防抖函数 */
function debounce(fn, delay) {
  let timer = null;
  return function (...args) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), delay);
  };
}
/** 节流函数 */
function throttle(fn, limit) {
  let inThrottle = false;
  return function (...args) {
    if (!inThrottle) {
      fn.apply(this, args);
      inThrottle = true;
      setTimeout(() => (inThrottle = false), limit);
    }
  };
}
/** UTF-8 安全的 base64 解码（支持中文等非 Latin1 字符） */
function base64Decode(str) {
  const binary = atob(str);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return new TextDecoder().decode(bytes);
}

/** 从 JWT 解析用户信息 */
function parseJwtInfo() {
  try {
    const jwt = localStorage.getItem('jwt');
    if (!jwt) return null;
    const payload = jwt.split('.')[1];
    if (!payload) return null;
    return JSON.parse(base64Decode(payload.replace(/-/g, '+').replace(/_/g, '/')));
  } catch {
    return null;
  }
}
/** 获取当前登录用户 ID */
function getCurrentUserId() {
  const info = parseJwtInfo();
  return info?.sub != null ? info.sub : null;
}
/** localStorage 存储工具 */
const storage = {
  get(key, defaultValue = null) {
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : defaultValue;
    } catch {
      return defaultValue;
    }
  },
  set(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      console.error('LocalStorage set error:', e);
    }
  },
  remove(key) {
    try {
      localStorage.removeItem(key);
    } catch (e) {
      console.error('LocalStorage remove error:', e);
    }
  },
};
// ── JWT 过期检测（复用 parseJwtInfo 避免重复解码逻辑）──
function isJwtExpired() {
  var info = parseJwtInfo();
  return !!(info && info.exp && info.exp * 1000 < Date.now());
}

// ── 登录过期弹窗（全局单例，CSS 类驱动 + 移动端 bottom-sheet 适配） ──
var _loginExpiredShown = false;

// ── 播放历史模块 ──
const HISTORY_KEY = 'hymns_play_history';
const MAX_HISTORY = 20;

const PlayHistory = {
  add(id, title, category) {
    if (!id || !title) return;
    try {
      let history = this.getAll();
      history = history.filter((item) => item.id !== id);
      history.unshift({ id, title, category: category || '', playedAt: Date.now() });
      if (history.length > MAX_HISTORY) history = history.slice(0, MAX_HISTORY);
      localStorage.setItem(HISTORY_KEY, JSON.stringify(history));
    } catch (e) {}
  },
  getAll() {
    try {
      const raw = localStorage.getItem(HISTORY_KEY);
      if (!raw) return [];
      const data = JSON.parse(raw);
      return Array.isArray(data) ? data : [];
    } catch (e) {
      return [];
    }
  },
  getRecent(limit) {
    return this.getAll().slice(0, limit || 10);
  },
  clear() {
    try {
      localStorage.removeItem(HISTORY_KEY);
    } catch (e) {}
  },
  remove(id) {
    try {
      const history = this.getAll().filter((item) => item.id !== id);
      localStorage.setItem(HISTORY_KEY, JSON.stringify(history));
    } catch (e) {}
  },
};
if (typeof window !== 'undefined') {
  window.PlayHistory = PlayHistory;
}

function showLoginExpired() {
  if (_loginExpiredShown) return;
  _loginExpiredShown = true;
  var redirect = encodeURIComponent(location.pathname + location.search);
  var overlay = document.createElement('div');
  overlay.className = 'login-expired-overlay';
  overlay.innerHTML =
    '<div class="login-expired-card">' +
    '<div class="login-expired-icon">🔒</div>' +
    '<div class="login-expired-title">登录已过期</div>' +
    '<div class="login-expired-desc">你的登录信息已失效，请重新登录</div>' +
    '<div class="login-expired-actions">' +
    '<a href="login.html?redirect=' +
    redirect +
    '" class="login-expired-btn primary">去登录</a>' +
    '<button class="login-expired-btn secondary" data-dismiss-login-expired>稍后</button>' +
    '</div>' +
    '</div>';
  document.body.appendChild(overlay);

  // 用事件委托替代内联 onclick，避免闭包变量穿透问题
  overlay.addEventListener('click', function (e) {
    if (e.target.matches('[data-dismiss-login-expired]')) {
      overlay.remove();
      _loginExpiredShown = false;
    }
  });
}

// 自动检测：页面加载时 JWT 已过期则弹出提示（登录/注册等认证页面跳过，用户已在登录流程中）
(function () {
  if (isJwtExpired()) {
    var path = location.pathname;
    // 认证页面不弹过期提示
    if (/\/(login|register|forgot-password|reset-password)(\.html)?($|\?|#)/.test(path)) {
      return;
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', showLoginExpired);
    } else {
      setTimeout(showLoginExpired, 100);
    }
  }
})();

/* ── Utils 导出到全局 ── */
const Utils = {
  escHtml,
  escAttr,
  formatSize,
  formatDate,
  formatDateTime,
  getYoutubeId,
  getYoutubeThumb,
  fmtDur,
  logout,
  detectFileType,
  getFileTypeIcon,
  getFileTypeLabel,
  showError,
  hideError,
  showSuccess,
  showErrorToast,
  showToast,
  fetchAuth,
  safeFetch,
  debounce,
  throttle,
  storage,
};
if (typeof window !== 'undefined') {
  window.Utils = Utils;
  // 单独导出到 window，确保 esbuild 打包后页面脚本仍能访问
  // 这些函数在 index.js / hymn.js / admin.js 等中作为裸名调用
  window.escHtml = escHtml;
  window.escAttr = escAttr;
  window.formatSize = formatSize;
  window.fmtDur = fmtDur;
  window.formatDate = formatDate;
  window.formatDateTime = formatDateTime;
  window.getYoutubeId = getYoutubeId;
  window.getYoutubeThumb = getYoutubeThumb;
  window.logout = logout;
  window.detectFileType = detectFileType;
  window.getFileTypeIcon = getFileTypeIcon;
  window.getFileTypeLabel = getFileTypeLabel;
  window.showToast = showToast;
  window.fetchAuth = fetchAuth;
  window.safeFetch = safeFetch;
  window.debounce = debounce;
  window.throttle = throttle;
  window.showLoginExpired = showLoginExpired;
  window.showError = showError;
  window.hideError = hideError;
  window.showSuccess = showSuccess;
  window.showErrorToast = showErrorToast;
  window.storage = storage;
  window.parseJwtInfo = parseJwtInfo;
  window.getCurrentUserId = getCurrentUserId;
  window.isJwtExpired = isJwtExpired;
}
//# sourceMappingURL=utils.js.map

'use strict';
/**
 * 统一 Header 组件
 *
 * renderHeader(containerId, options) — 渲染完整 <header>
 *
 * options:
 *   title        — 页面标题（居中显示）
 *   type         — 'default' | 'home' | 'minimal'
 *   showBack     — 是否显示返回按钮
 *   backUrl      — 返回按钮跳转链接（默认 history.back）
 *   showUserMenu — 默认 true
 *   subtitle     — type='home' 时品牌下方的副标题
 */
/* ── 转义函数（优先使用 Utils，后备自身） ── */
function _escHtml(s) {
  if (typeof window.Utils !== 'undefined' && window.Utils.escHtml) {
    return window.Utils.escHtml(s);
  }
  return String(s || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}
function _escAttr(s) {
  if (typeof window.Utils !== 'undefined' && window.Utils.escAttr) {
    return window.Utils.escAttr(s);
  }
  return String(s || '')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

/* ── SVG 图标缓存 ── */
const ICONS = {
  upload:
    '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>',
  settings:
    '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>',
  logout:
    '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>',
  home: '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>',
  playlist:
    '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M8 6h13"/><path d="M8 12h13"/><path d="M8 18h13"/><path d="M3 6h.01"/><path d="M3 12h.01"/><path d="M3 18h.01"/></svg>',
  folder:
    '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/></svg>',
  arrowLeft:
    '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>',
  music:
    '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18V5l12-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="16" r="3"/></svg>',
};

/**
 * 渲染统一 Header
 * 三栏 grid 布局：左侧品牌 | 中间标题（绝对居中）| 右侧用户菜单
 *
 * type 支持：
 *   'default' — 完整三栏（品牌 + 标题 + 用户菜单）
 *   'home'    — 首页模式（品牌 + 用户菜单，无标题栏，支持自定义副标题）
 *   'minimal' — 极简登录页模式
 */
function renderHeader(containerId, options) {
  const container = document.getElementById(containerId);
  if (!container) return;
  const { title, showBack, backUrl, showUserMenu = true, type = 'default', subtitle } = options || {};

  // ── 左侧：品牌 ──
  const brandSub = subtitle || '诗歌音频 · 歌谱乐谱 · 歌词文本';
  const brandHtml = `<a class="logo-wrap header-brand" href="/" style="text-decoration:none;color:inherit">
    <div class="logo-mark header-brand-icon">${ICONS.music}</div>
    <div class="logo-text">
      <h1>赞美诗资料库</h1>
      <p class="header-brand-sub">${_escHtml(brandSub)}</p>
    </div>
  </a>`;

  let leftHtml, centerHtml, rightHtml;
  const isMinimal = type === 'minimal';

  if (type === 'home') {
    // 首页模式：品牌 + 用户菜单，无标题，无返回
    leftHtml = brandHtml;
    rightHtml = showUserMenu ? buildUserMenuHtml() : '';
    container.innerHTML = `<header class="site-header home-header">
      <div class="header-left">${leftHtml}</div>
      <div class="header-center"></div>
      <div class="header-right">${rightHtml}</div>
    </header>`;
  } else if (isMinimal) {
    leftHtml = brandHtml;
    centerHtml = title ? `<span class="header-title">${_escHtml(title)}</span>` : '';
    rightHtml = showUserMenu ? buildUserMenuHtml() : '';
    container.innerHTML = `<header class="site-header auth-header">
      <div class="header-left">${leftHtml}</div>
      <div class="header-center">${centerHtml}</div>
      <div class="header-right">${rightHtml}</div>
    </header>`;
    document.body.classList.add('has-minimal-header');
  } else {
    // Default：品牌 + 返回 + 标题 + 用户菜单
    if (showBack) {
      const backOnClick = backUrl ? `location.href='${_escAttr(backUrl)}'` : 'history.back()';
      leftHtml =
        brandHtml +
        `<button class="header-back" onclick="${backOnClick}" aria-label="返回">${ICONS.arrowLeft}</button>`;
    } else {
      leftHtml = brandHtml;
    }
    centerHtml = title
      ? `<div class="header-center"><span class="header-title">${_escHtml(title)}</span></div>`
      : `<div class="header-center"></div>`;
    rightHtml = showUserMenu ? buildUserMenuHtml() : '';
    container.innerHTML = `<header class="site-header">
      <div class="header-left">${leftHtml}</div>
      ${centerHtml}
      <div class="header-right">${rightHtml}</div>
    </header>`;
  }
}

/**
 * 构建用户菜单 HTML
 */
function buildUserMenuHtml() {
  const jwt = localStorage.getItem('jwt');
  const nickname = localStorage.getItem('nickname');
  const avatarUrl = localStorage.getItem('avatar_url');
  const canUpload = localStorage.getItem('canUpload');
  const initial = (nickname || '?')[0]?.toUpperCase() || '?';
  if (!jwt) {
    return '<a href="/login" class="header-login-btn">登录</a>';
  }
  const noticeIcon =
    '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>';
  // 通知铃铛下拉面板
  let html = '<div class="notice-container" id="noticeContainer">';
  html += `<button class="notice-bell" onclick="toggleNotifications()" title="通知">${noticeIcon}<span class="notice-bell-dot" id="noticeBellDot"></span></button>`;
  html += '<div class="notice-dropdown" id="noticeDropdown">';
  html += '<div class="notice-dropdown-header">通知</div>';
  // 通知 1：小程序上线
  html += `<button class="notice-item" onclick="handleNotifClick('miniapp')" id="notifItemMiniapp">
    <span class="notice-item-icon">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>
    </span>
    <div class="notice-item-body">
      <strong>微信小程序已上线</strong>
      <span>在微信中搜索「麦子库」或扫码即可使用</span>
    </div>
  </button>`;
  // 通知 2：绑定邮箱（微信用户可见）
  html += `<button class="notice-item" onclick="handleNotifClick('bind_email')" id="notifItemBindEmail">
    <span class="notice-item-icon">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>
    </span>
    <div class="notice-item-body">
      <strong>绑定邮箱</strong>
      <span>绑定邮箱后可使用邮箱+密码登录</span>
    </div>
  </button>`;
  html += '</div></div>';
  html += '<div class="user-menu" id="userMenu">';
  html += `<div class="avatar" onclick="toggleHeaderDropdown()" title="${_escAttr(nickname || '用户')}">`;
  if (avatarUrl) {
    html += `<img src="${_escAttr(avatarUrl)}" alt="" loading="lazy" style="width:100%;height:100%;border-radius:50%;object-fit:cover;" onerror="this.style.display='none';this.parentElement.textContent='${_escHtml(initial)}';this.parentElement.style.background='rgba(255,255,255,0.18)'" />`;
  } else {
    html += _escHtml(initial);
  }
  html += '</div>';
  html += '<div class="dropdown" id="headerDropdown">';
  html += `<div class="dropdown-header"><div class="name">${_escHtml(nickname || '用户')}</div>`;
  html += canUpload === '1' ? '<span class="perm yes">已获上传权限</span>' : '<span class="perm no">待授权上传</span>';
  html += '</div>';
  html += `<button class="dropdown-item" onclick="location.href='/'">${ICONS.home} 回到首页</button>`;
  html += '<div class="dropdown-divider"></div>';
  html += `<button class="dropdown-item" onclick="location.href='/search'">
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="flex-shrink:0"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>
    搜索 YouTube
  </button>`;
  html += `<button class="dropdown-item" onclick="location.href='/download'">
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="flex-shrink:0"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
    下载入库
  </button>`;
  html += `<button class="dropdown-item" onclick="location.href='/yt-download'">
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="flex-shrink:0"><polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2" ry="2"/></svg>
    YouTube下载站
  </button>`;
  html += '<div class="dropdown-divider"></div>';
  html += `<button class="dropdown-item" onclick="location.href='/files'">${ICONS.folder} 我的文件</button>`;
  if (canUpload === '1') {
    html += `<button class="dropdown-item" onclick="location.href='/upload'">${ICONS.upload} 上传文件</button>`;
  }
  html += `<button class="dropdown-item" onclick="location.href='/playlist'">${ICONS.playlist} 我的播放列表</button>`;
  html += `<button class="dropdown-item" onclick="location.href='/settings'">${ICONS.settings} 账户设置</button>`;
  html += '<div class="dropdown-divider"></div>';
  html += `<button class="dropdown-item danger" onclick="doLogout()">${ICONS.logout} 退出登录</button>`;
  html += '</div></div>';
  return html;
}

/**
 * 渲染统一 Header 右侧菜单（兼容 index.html 首页，保留向后兼容）
 */
function renderUnifiedHeader(containerId) {
  const container = document.getElementById(containerId);
  if (!container) return;
  container.innerHTML = buildUserMenuHtml();
}

function toggleHeaderDropdown() {
  document.getElementById('headerDropdown')?.classList.toggle('show');
}

// ══════════════════════════════════════════
// 通知铃铛下拉面板
// ══════════════════════════════════════════
function toggleNotifications() {
  var dd = document.getElementById('noticeDropdown');
  if (dd) dd.classList.toggle('show');
}

function handleNotifClick(key) {
  if (key === 'miniapp') {
    localStorage.setItem('notif_read_miniapp', '1');
    location.href = '/notice';
  } else if (key === 'bind_email') {
    localStorage.setItem('notif_read_bind_email', '1');
    location.href = '/settings.html#email';
  }
  updateNotifDot();
}

/** 从 JWT 中取 email（复用 parseJwtInfo 避免重复解码逻辑） */
function _getJwtEmail() {
  var info = parseJwtInfo();
  return (info && info.email) || null;
}

function updateNotifDot() {
  var dot = document.getElementById('noticeBellDot');
  var bindItem = document.getElementById('notifItemBindEmail');
  if (!dot) return;

  var hasUnread = false;

  // 小程序上线通知：默认未读
  if (localStorage.getItem('notif_read_miniapp') !== '1') {
    hasUnread = true;
  }

  // 绑定邮箱通知：仅微信用户显示，未读时加红点
  var email = _getJwtEmail();
  var isWechatUser = email && email.startsWith('wx_');
  if (bindItem) {
    bindItem.style.display = isWechatUser ? '' : 'none';
  }
  if (isWechatUser && localStorage.getItem('notif_read_bind_email') !== '1') {
    hasUnread = true;
  }

  dot.style.display = hasUnread ? '' : 'none';
}

function doLogout() {
  localStorage.removeItem('jwt');
  localStorage.removeItem('nickname');
  localStorage.removeItem('avatar_url');
  localStorage.removeItem('canUpload');
  location.href = '/';
}

// 点击外部关闭所有下拉菜单
document.addEventListener('click', (e) => {
  const menu = document.getElementById('userMenu');
  if (menu && !menu.contains(e.target)) {
    document.getElementById('headerDropdown')?.classList.remove('show');
  }
  const nc = document.getElementById('noticeContainer');
  if (nc && !nc.contains(e.target)) {
    document.getElementById('noticeDropdown')?.classList.remove('show');
  }
});

// 页面加载后更新通知红点
if (document.readyState === 'complete') {
  setTimeout(updateNotifDot, 300);
} else {
  window.addEventListener('load', function () {
    setTimeout(updateNotifDot, 300);
  });
}

// ══════════════════════════════════════════
// PWA 安装提示
// ══════════════════════════════════════════
let _deferredPrompt = null;

/** 检查是否可安装 PWA */
function checkPwaInstall() {
  // 已安装（display-mode: standalone）则跳过
  if (window.matchMedia('(display-mode: standalone)').matches) return;
  // 已被用户关闭过
  if (localStorage.getItem('pwa_install_dismissed')) return;
  // 有 deferredPrompt 才显示提示
  if (!_deferredPrompt) return;

  const banner = document.getElementById('pwaInstallBanner');
  if (banner) banner.style.display = 'flex';
}

function installPwa() {
  if (!_deferredPrompt) return;
  _deferredPrompt.prompt();
  _deferredPrompt.userChoice.then((choiceResult) => {
    if (choiceResult.outcome === 'accepted') {
      const banner = document.getElementById('pwaInstallBanner');
      if (banner) banner.style.display = 'none';
      localStorage.setItem('pwa_install_dismissed', '1');
    }
    _deferredPrompt = null;
  });
}

function dismissPwaInstall() {
  const banner = document.getElementById('pwaInstallBanner');
  if (banner) banner.style.display = 'none';
  localStorage.setItem('pwa_install_dismissed', '1');
  _deferredPrompt = null;
}

// 监听 beforeinstallprompt
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  _deferredPrompt = e;
  setTimeout(checkPwaInstall, 1000);
});

// 监听 appinstalled
window.addEventListener('appinstalled', () => {
  localStorage.setItem('pwa_install_dismissed', '1');
});

// 启动时检查
if (document.readyState === 'complete') {
  setTimeout(checkPwaInstall, 2000);
} else {
  window.addEventListener('load', () => setTimeout(checkPwaInstall, 2000));
}

// 注入 PWA 安装提示的 HTML
(function injectPwaBanner() {
  // Only inject once
  if (document.getElementById('pwaInstallBanner')) return;
  // Wait for body
  const checkBody = () => {
    if (!document.body) {
      setTimeout(checkBody, 100);
      return;
    }
    const div = document.createElement('div');
    div.id = 'pwaInstallBanner';
    div.className = 'pwa-install-banner';
    div.style.display = 'none';
    div.innerHTML = `
      <div class="pwa-install-content">
        <div class="pwa-install-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <rect x="4" y="4" width="16" height="16" rx="2" ry="2"/>
            <line x1="12" y1="8" x2="12" y2="16"/>
            <line x1="8" y1="12" x2="16" y2="12"/>
          </svg>
        </div>
        <div class="pwa-install-text">
          <strong>安装「赞美诗资料库」</strong>
          <span>像 App 一样使用，离线也可访问</span>
        </div>
        <button class="pwa-install-btn" onclick="installPwa()">安装</button>
        <button class="pwa-install-close" onclick="dismissPwaInstall()" aria-label="关闭">&times;</button>
      </div>
    `;
    document.body.appendChild(div);
  };
  checkBody();
})();

if (typeof window !== 'undefined') {
  window.renderHeader = renderHeader;
  window.renderUnifiedHeader = renderUnifiedHeader;
  window.toggleHeaderDropdown = toggleHeaderDropdown;
  window.toggleNotifications = toggleNotifications;
  window.handleNotifClick = handleNotifClick;
  window.updateNotifDot = updateNotifDot;
  window.doLogout = doLogout;
  window.checkPwaInstall = checkPwaInstall;
  window.installPwa = installPwa;
  window.dismissPwaInstall = dismissPwaInstall;
}
//# sourceMappingURL=header.js.map

'use strict';
/**
 * player-persist.ts
 * Cross-page player state persistence.
 * Saves/restores playback state via localStorage.
 * Must be loaded BEFORE the player instance is initialized.
 */
const PLAYER_STORAGE_KEY = 'hymns_player_state';
/** 保存播放器状态到 localStorage */
function savePlayerState(player, audio, forcePaused) {
  try {
    const state = {
      queue: player.queue || [],
      currentIndex: player.currentIndex != null ? player.currentIndex : -1,
      mode: player.mode || 'sequence',
      currentTime: audio ? audio.currentTime : 0,
      paused: forcePaused !== undefined ? forcePaused : audio ? audio.paused : true,
      savedAt: Date.now(),
    };
    localStorage.setItem(PLAYER_STORAGE_KEY, JSON.stringify(state));
    // 折叠状态已由 toggleCollapse() 和 _show() 分别在修改时保存，此处不再冗余写入
  } catch (e) {
    // Silently fail
  }
}
/** 读取播放器状态（24 小时内有效） */
function loadPlayerState() {
  try {
    const raw = localStorage.getItem(PLAYER_STORAGE_KEY);
    if (!raw) return null;
    const state = JSON.parse(raw);
    if (!state || !Array.isArray(state.queue) || state.queue.length === 0) {
      localStorage.removeItem(PLAYER_STORAGE_KEY);
      return null;
    }
    if (Date.now() - state.savedAt > 86400000) {
      localStorage.removeItem(PLAYER_STORAGE_KEY);
      return null;
    }
    return state;
  } catch (e) {
    localStorage.removeItem(PLAYER_STORAGE_KEY);
    return null;
  }
}
/** 清除播放器状态 */
function clearPlayerState() {
  localStorage.removeItem(PLAYER_STORAGE_KEY);
}
/** 限流保存（最多每 2 秒一次，用于 timeupdate） */
let _lastSaveTime = 0;
function throttledSavePlayerState(player, audio) {
  const now = Date.now();
  if (now - _lastSaveTime < 2000) return;
  _lastSaveTime = now;
  savePlayerState(player, audio);
}
/* ── pagehide: 页面隐藏/进入 bfcache 前立即保存 state ── */
/* 与 beforeunload 不同，pagehide 在浏览器暂停媒体元素之前触发，
   因此 audio.paused 反映的是真实的用户操作状态（而非浏览器强制暂停） */
window.addEventListener('pagehide', () => {
  const p = typeof window.player !== 'undefined' ? window.player : null;
  if (p) {
    const audio = document.getElementById('globalAudio') || document.getElementById('hymnAudio');
    if (audio && audio.src && audio.src !== window.location.href) {
      // 使用 _wasPlaying 标志确定真实播放状态（避免浏览器在 pagehide 前已暂停音频）
      savePlayerState(p, audio, p._wasPlaying === true ? false : true);
      // 每曲进度立即跨设备同步（force=true 绕过节流，与视频 pagehide forceSave 对齐）
      if (typeof p._saveTrackProgress === 'function') p._saveTrackProgress(true);
    }
  }
});
/* ── bfcache / back-forward cache handler ── */
window.addEventListener('pageshow', (e) => {
  // 恢复折叠状态
  const bar = document.getElementById('globalPlayer');
  if (bar) {
    try {
      const saved = localStorage.getItem('player_collapsed');
      if (saved === '1') {
        bar.classList.add('collapsed');
      } else if (saved === '0') {
        bar.classList.remove('collapsed');
      }
    } catch (e) {}
  }
  const p = typeof window.player !== 'undefined' ? window.player : null;
  if (e.persisted && p) {
    const state = loadPlayerState();
    if (state && Array.isArray(state.queue) && state.queue.length > 0) {
      p.queue = state.queue;
      p.currentIndex = Math.max(0, Math.min(state.currentIndex ?? 0, state.queue.length - 1));
      p.mode = state.mode || 'sequence';
      // 恢复模式后同步下拉框（与 _restoreState 保持一致）
      if (typeof p._syncModeUI === 'function') p._syncModeUI();
      const item = p.queue[p.currentIndex];
      if (item && item.id != null) {
        const audio = document.getElementById('globalAudio') || document.getElementById('hymnAudio');
        if (audio) {
          const baseUrl = window.API_BASE || window.API || '';
          const expectedUrl = `${baseUrl}/api/download/${item.idType === 'hymn' ? 'hymn' : 'file'}/${item.id}`;
          const aud = audio;
          if (aud.src !== expectedUrl) {
            aud.src = expectedUrl;
            if (Number.isFinite(state.currentTime) && state.currentTime > 0) {
              const seekTo = state.currentTime;
              audio.addEventListener(
                'loadedmetadata',
                () => {
                  aud.currentTime = seekTo;
                },
                { once: true },
              );
            }
          }
          // bfcache 恢复时音频元素状态可能已冻结（paused=false 但无实际输出）
          // 因此根据 state.paused 而非 aud.paused 来判断是否需要恢复播放
          if (state.paused === false) {
            aud
              .play()
              .then(() => {
                if (typeof p._updatePlayBtn === 'function') p._updatePlayBtn();
              })
              .catch(() => {
                // Autoplay 被浏览器拦截——更新按钮以反映实际暂停状态
                if (typeof p._updatePlayBtn === 'function') p._updatePlayBtn();
              });
          } else if (typeof p._updatePlayBtn === 'function') {
            p._updatePlayBtn();
          }
        }
      }
      const titleEl = document.getElementById('playerTitle');
      if (titleEl) titleEl.textContent = (item && item.title) || '未在播放';
      if (typeof p._show === 'function') p._show();
      if (typeof p._updateQueueUI === 'function') p._updateQueueUI();
    }
  }
});
/* ── 绑定到全局 ── */
if (typeof window !== 'undefined') {
  window.savePlayerState = savePlayerState;
  window.loadPlayerState = loadPlayerState;
  window.clearPlayerState = clearPlayerState;
  window.throttledSavePlayerState = throttledSavePlayerState;
}
//# sourceMappingURL=player-persist.js.map

'use strict';
/**
 * 赞美诗资料库 - 全局播放器模块
 */
class HymnPlayer {
  constructor() {
    this.queue = [];
    this.currentIndex = -1;
    this.mode = 'sequence';
    this.playlistModalOpen = false;
    this._initialized = false;
    this._audioHandlers = null;
    this._wasPlaying = false;
    this._playerCollapsed = false; // JS 变量追踪折叠状态，pagehide 时比 DOM class 更可靠
    // 音量（参考 APlayer 补齐）
    this.volume = 0.8;
    this.muted = false;
    // 全局歌词面板
    this._lyrics = []; // [{ t, l }]
    this._lyricIndex = -1;
    this._lyricsOpen = false;
    // 每曲进度跨设备同步节流（timeupdate 60s 兜底，pause/pagehide/切歌立即保存）
    this._lastTrackSave = 0;
    this._lastTrackKey = null; // 当前已加载曲目的进度 key（切歌前用于保存上一曲）
    this._randomSiteLoading = false;
  }
  get _API() {
    return window.API_BASE || window.API || '';
  }
  init() {
    if (this._initialized) return;
    const audio = this._getAudioElement();
    if (!audio) return;
    this._bindEvents(audio);
    this._restoreVolume();
    this._loadPlaylists();
    // 先恢复折叠状态，作为初始显示
    try {
      const saved = localStorage.getItem('player_collapsed');
      const bar = document.getElementById('globalPlayer');
      if (bar) {
        if (saved === '1') bar.classList.add('collapsed');
        else bar.classList.remove('collapsed');
      }
    } catch (e) {}
    this._show();
    this._restoreState();
    // 启动时预热跨设备进度合并（含音频 audio_progress_ 前缀，fire-and-forget）；
    // 合并完成后若当前曲目尚未开始播放（<5s），重试跨设备续播（对齐视频的 done 回调）
    _syncProgressFromServer(() => {
      const audio = this._getAudioElement();
      const item = this.queue[this.currentIndex];
      if (!audio || !item || item.id == null) return;
      if (audio.currentTime >= 5) return; // 已开始播放/已手动 seek，不打扰
      this._tryResumeTrack(item);
    });
    this._show();
    this._initialized = true;
  }
  _getAudioElement() {
    const el = document.getElementById('globalAudio') || document.getElementById('hymnAudio');
    return el;
  }
  _bindEvents(audio) {
    this._cleanupEvents(audio);
    this._audioHandlers = {
      ended: () => {
        // 播完清除当前曲目进度（t=0 哨兵同步到服务端，避免下次从结尾续播）
        this._clearTrackProgress();
        this.next();
      },
      timeupdate: () => {
        this._updateProgress();
        // 歌词面板同步高亮（仅面板打开时有效）
        this._updateLyricUI(audio.currentTime);
        if (typeof window.throttledSavePlayerState === 'function') {
          window.throttledSavePlayerState(this, audio);
        }
        // 每曲进度跨设备同步：timeupdate 60s 兜底保存（pause/pagehide/切歌立即）
        this._saveTrackProgress();
        // 当前曲目播放到接近末尾时（剩余 < 10s 或 > 80%），预加载下一首
        this._preloadNext();
      },
      loadedmetadata: () => {
        this._updateProgress();
      },
      pause: () => {
        // 暂停立即保存进度（force=true 绕过节流）
        this._saveTrackProgress(true);
      },
    };
    audio.addEventListener('ended', this._audioHandlers.ended);
    audio.addEventListener('timeupdate', this._audioHandlers.timeupdate);
    audio.addEventListener('loadedmetadata', this._audioHandlers.loadedmetadata);
    audio.addEventListener('pause', this._audioHandlers.pause);
    const progress = document.getElementById('playerProgress');
    if (progress) {
      progress.addEventListener('input', (e) => {
        audio.currentTime = parseFloat(e.target.value);
      });
    }
    // 音量滑块（参考 APlayer 补齐）
    const volSlider = document.getElementById('playerVolume');
    if (volSlider) {
      volSlider.addEventListener('input', (e) => {
        this.setVolume(parseFloat(e.target.value) / 100);
      });
    }
    // 键盘快捷键：空格播放/暂停、←→快退快进 5s、↑↓音量 ±0.1、M 静音
    document.addEventListener('keydown', (e) => {
      const tag = document.activeElement?.tagName;
      // 焦点在视频元素上时，交给视频自身的快捷键处理（见 window.enhanceVideo）
      const inForm = tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || tag === 'VIDEO';
      if (inForm) return;
      if (e.key === ' ') {
        e.preventDefault();
        this.togglePlay();
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
        const audioEl = this._getAudioElement();
        if (!audioEl || !audioEl.src || audioEl.src === window.location.href) return;
        e.preventDefault();
        const delta = e.key === 'ArrowRight' ? 5 : -5;
        audioEl.currentTime = Math.max(0, Math.min(audioEl.duration || 0, audioEl.currentTime + delta));
        this._updateProgress();
      } else if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
        e.preventDefault();
        this.setVolume(this.volume + (e.key === 'ArrowUp' ? 0.1 : -0.1));
      } else if (e.key === 'm' || e.key === 'M') {
        e.preventDefault();
        this.toggleMute();
      }
    });
  }
  _cleanupEvents(audio) {
    if (!audio || !this._audioHandlers) return;
    audio.removeEventListener('ended', this._audioHandlers.ended);
    audio.removeEventListener('timeupdate', this._audioHandlers.timeupdate);
    audio.removeEventListener('loadedmetadata', this._audioHandlers.loadedmetadata);
    audio.removeEventListener('pause', this._audioHandlers.pause);
  }
  _loadPlaylists() {
    const jwt = localStorage.getItem('jwt');
    if (!jwt) return;
    fetch(`${this._API}/api/playlists`, {
      headers: { Authorization: `Bearer ${jwt}` },
    })
      .then((r) => r.json())
      .then((data) => {
        const sel = document.getElementById('plListSelect');
        if (!sel) return;
        const lists = Array.isArray(data) ? data : [];
        sel.innerHTML = lists
          .map((p) => `<option value="${String(p.id)}">${(p.name || '').replace(/"/g, '&quot;')}</option>`)
          .join('');
      })
      .catch(() => {});
  }
  _restoreState() {
    const state = typeof window.loadPlayerState === 'function' ? window.loadPlayerState() : null;
    if (!state || !Array.isArray(state.queue) || state.queue.length === 0) return;
    const idx = Math.max(0, Math.min(state.currentIndex ?? 0, state.queue.length - 1));
    this.queue = state.queue;
    this.currentIndex = idx;
    this.mode = state.mode || 'sequence';
    this._syncModeUI(); // 恢复模式后同步下拉框，避免显示默认值与实际模式不一致
    const item = this.queue[idx];
    if (item && item.id != null) {
      this._lastTrackKey = this._trackProgressKey(item);
      // 恢复状态时同步加载歌词（面板打开时渲染）
      this._loadLyrics(item);
      const audio = this._getAudioElement();
      const titleEl = document.getElementById('playerTitle');
      if (audio && titleEl) {
        const url = `${this._API}/api/download/${item.idType === 'hymn' ? 'hymn' : 'file'}/${item.id}`;
        this._setTitleText(item.title || '未知曲目');
        if (audio.src !== url) {
          audio.src = url;
          audio.load();
        }
        // 恢复保存的播放进度
        if (Number.isFinite(state.currentTime) && state.currentTime > 0) {
          const seekTo = state.currentTime;
          audio.addEventListener(
            'loadedmetadata',
            function () {
              audio.currentTime = seekTo;
            },
            { once: true },
          );
        }
        // 根据用户离开时的状态决定是否播放
        if (state.paused === false) {
          this._wasPlaying = true;
          // 设置 Media Session（锁屏/通知栏显示歌曲标题）
          if ('mediaSession' in navigator) {
            navigator.mediaSession.metadata = new MediaMetadata({
              title: item.title || '未知曲目',
              artist: '赞美诗',
              artwork: [
                { src: '/icons/icon-512.png', sizes: '512x512', type: 'image/png' },
                { src: '/icons/icon-192.png', sizes: '192x192', type: 'image/png' },
              ],
            });
            navigator.mediaSession.setActionHandler('play', () => this.togglePlay());
            navigator.mediaSession.setActionHandler('pause', () => this.togglePlay());
            navigator.mediaSession.setActionHandler('previoustrack', () => this.prev());
            navigator.mediaSession.setActionHandler('nexttrack', () => this.next());
            navigator.mediaSession.playbackState = 'playing';
          }
          audio.play().catch(() => console.warn('[player] 恢复播放失败，用户可能未与页面交互'));
        } else {
          this._wasPlaying = false;
          // 显式暂停，防止某些浏览器在 load() 后自动播放
          try {
            audio.pause();
          } catch (e) {}
          // 加载完毕后的 currentTime 复原在 loadedmetadata 事件中处理
        }
      }
    }
    this._show();
    this._updateQueueUI();
    this._updatePlayBtn();
    // 修正持久化的 paused 字段：_loadAndPlay 在 audio.play() 尚未 resolve 时
    // 保存 state 会导致 paused=true 被覆盖。现在不调用 _loadAndPlay 所以不存在此问题。
    // 但仍需确保 localStorage 中的 paused 与 state.paused 一致。
    try {
      const raw = localStorage.getItem('hymns_player_state');
      if (raw) {
        const corrected = JSON.parse(raw);
        corrected.paused = state.paused === false ? false : true;
        localStorage.setItem('hymns_player_state', JSON.stringify(corrected));
      }
    } catch (e) {}
  }
  /** 当前曲目的跨设备进度 key（localStorage audio_progress_ 前缀 + 服务端 audio- 前缀） */
  _trackProgressKey(item) {
    const idType = item && item.idType === 'hymn' ? 'hymn' : 'file';
    return idType + '-' + item.id;
  }
  /** 保存曲目进度到 localStorage + 跨设备同步（explicitKey 传旧曲 key 用于切歌前保存上一曲） */
  _saveTrackProgress(force, explicitKey) {
    const audio = this._getAudioElement();
    const item = this.queue[this.currentIndex];
    const trackKey = explicitKey || (item ? this._trackProgressKey(item) : null);
    if (!audio || !trackKey) return;
    if (!audio.duration || !isFinite(audio.duration)) return;
    const now = Date.now();
    if (force !== true && now - this._lastTrackSave < 60000) return;
    this._lastTrackSave = now;
    const data = { t: audio.currentTime, duration: audio.duration, updated_at: now };
    try {
      localStorage.setItem('audio_progress_' + trackKey, JSON.stringify(data));
    } catch (e) {}
    // 跨设备同步（fire-and-forget，跟随同一节流节奏）
    _syncProgressToServer('audio-' + trackKey, data.t, data.duration);
  }
  /** 播完清除当前曲目进度（t=0 哨兵同步到服务端，等效清除） */
  _clearTrackProgress() {
    const item = this.queue[this.currentIndex];
    if (!item || item.id == null) return;
    const trackKey = this._trackProgressKey(item);
    try {
      localStorage.setItem('audio_progress_' + trackKey, JSON.stringify({ t: 0, duration: 0, updated_at: Date.now() }));
    } catch (e) {}
    _syncProgressToServer('audio-' + trackKey, 0, 0);
    // 已清除（播完），切歌时不再重复保存旧曲
    this._lastTrackKey = null;
  }
  /** 跨设备续播：恢复上次进度（<5s 或接近结尾跳过），本地无记录则忽略 */
  _tryResumeTrack(item) {
    if (!item || item.id == null) return;
    const trackKey = this._trackProgressKey(item);
    let saved = null;
    try {
      saved = JSON.parse(localStorage.getItem('audio_progress_' + trackKey));
    } catch (e) {}
    if (!saved || !isFinite(saved.t) || saved.t < 5) return;
    const audio = this._getAudioElement();
    if (!audio || !audio.duration || !isFinite(audio.duration)) return;
    if (saved.t > audio.duration - 10) return;
    audio.currentTime = saved.t;
  }
  _loadAndPlay(item) {
    const audio = this._getAudioElement();
    const titleEl = document.getElementById('playerTitle');
    if (!audio || !titleEl) return;
    // 切歌前保存上一曲进度（force 立即写，避免换 src 时丢失最后一段进度）
    const newKey = this._trackProgressKey(item);
    if (this._lastTrackKey && this._lastTrackKey !== newKey) {
      this._saveTrackProgress(true, this._lastTrackKey);
    }
    this._lastTrackKey = newKey;
    // 切歌时同步加载歌词（面板打开时渲染，否则仅缓存）
    this._loadLyrics(item);
    const url = `${this._API}/api/download/${item.idType === 'hymn' ? 'hymn' : 'file'}/${item.id}`;
    this._setTitleText(item.title || '未知曲目');
    // 设置 Media Session（锁屏/通知栏显示歌曲标题）
    if ('mediaSession' in navigator) {
      navigator.mediaSession.metadata = new MediaMetadata({
        title: item.title || '未知曲目',
        artist: '赞美诗',
        artwork: [
          { src: '/icons/icon-512.png', sizes: '512x512', type: 'image/png' },
          { src: '/icons/icon-192.png', sizes: '192x192', type: 'image/png' },
        ],
      });
      navigator.mediaSession.setActionHandler('play', () => this.togglePlay());
      navigator.mediaSession.setActionHandler('pause', () => this.togglePlay());
      navigator.mediaSession.setActionHandler('previoustrack', () => this.prev());
      navigator.mediaSession.setActionHandler('nexttrack', () => this.next());
      navigator.mediaSession.playbackState = 'playing';
    }
    if (audio.src !== url) {
      audio.src = url;
      audio.load();
      // 跨设备续播：元数据就绪后恢复上次进度（本地无记录则忽略，<5s 或接近结尾跳过）
      audio.addEventListener('loadedmetadata', () => this._tryResumeTrack(item), { once: true });
      audio.play().catch(() => console.warn('[player] 恢复播放被浏览器拦截'));
    } else {
      audio.currentTime = 0;
      audio.play().catch(() => console.warn('[player] 恢复播放被浏览器拦截'));
    }
    this._wasPlaying = true;
    this._updatePlayBtn();
    this._updateQueueUI();
    if (typeof window.savePlayerState === 'function') {
      window.savePlayerState(this, audio);
    }
    // 上报播放计数（fire-and-forget，不阻塞播放）
    fetch(`${this._API}/api/hymn/${item.id}/play`, { method: 'POST' }).catch(function () {
      /* fire-and-forget，播放计数上报不需要处理错误 */
    });
    // 记录播放历史
    if (typeof window.PlayHistory !== 'undefined') {
      window.PlayHistory.add(item.id, item.title);
    }
  }
  _setTitleText(text) {
    const el = document.getElementById('playerTitle');
    if (!el) return;
    const safeText = String(text || '未在播放')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
    el.innerHTML = '<span class="title-text">' + safeText + '</span>';
    // 检测是否溢出，添加滚动动画
    requestAnimationFrame(function () {
      var inner = el.querySelector('.title-text');
      if (inner && inner.scrollWidth > el.clientWidth) {
        el.classList.add('marquee');
      } else {
        el.classList.remove('marquee');
      }
    });
  }
  _show() {
    const bar = document.getElementById('globalPlayer');
    if (bar) {
      bar.style.display = 'flex';
      document.body.classList.add('has-player');
      // 队列为空时始终折叠；队列有内容时优先使用用户保存的折叠状态
      if (this.queue.length === 0) {
        bar.classList.add('collapsed');
        this._playerCollapsed = true;
      } else {
        try {
          const saved = localStorage.getItem('player_collapsed');
          if (saved === '1') {
            bar.classList.add('collapsed');
            this._playerCollapsed = true;
          } else {
            bar.classList.remove('collapsed');
            this._playerCollapsed = false;
          }
        } catch (e) {
          bar.classList.remove('collapsed');
          this._playerCollapsed = false;
        }
      }
      const height = bar.offsetHeight;
      document.documentElement.style.setProperty('--player-h', `${height}px`);
    }
  }
  _updatePlayBtn() {
    const btn = document.getElementById('playerPlayBtn');
    const audio = this._getAudioElement();
    if (!btn || !audio) return;
    btn.innerHTML = audio.paused
      ? '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><polygon points="8 5 19 12 8 19 8 5"/></svg>'
      : '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/></svg>';
    const bar = document.getElementById('globalPlayer');
    if (bar) {
      bar.classList.toggle('playing', !audio.paused);
    }
  }
  _updateProgress() {
    const audio = this._getAudioElement();
    const progress = document.getElementById('playerProgress');
    const timeEl = document.getElementById('playerTime');
    if (!audio || !progress || !timeEl) return;
    // 音频 metadata 未加载完成时（readyState < 1），始终显示占位符
    if (!audio.duration || !isFinite(audio.duration) || audio.readyState < 1) {
      timeEl.textContent = '--:-- / --:--';
      return;
    }
    progress.max = String(Math.floor(audio.duration));
    progress.value = String(Math.floor(audio.currentTime));
    const cm = Math.floor(audio.currentTime / 60);
    const cs = Math.floor(audio.currentTime % 60);
    const dm = Math.floor(audio.duration / 60);
    const ds = Math.floor(audio.duration % 60);
    timeEl.textContent = `${cm}:${cs < 10 ? '0' : ''}${cs} / ${dm}:${ds < 10 ? '0' : ''}${ds}`;
  }
  _updateQueueUI() {
    const countEl = document.getElementById('playerQueueCount');
    const listEl = document.getElementById('plList');
    if (countEl) countEl.textContent = String(this.queue.length);
    if (!listEl) return;
    if (this.queue.length === 0) {
      listEl.innerHTML = '<div class="pl-empty">队列为空</div>';
      return;
    }
    listEl.innerHTML = this.queue
      .map(
        (
          item,
          i,
        ) => `<div class="pl-item${i === this.currentIndex ? ' active' : ''}" onclick="window.player._jumpTo(${i})">
            <span class="pl-item-title">${(item.title || '未知').replace(/"/g, '&quot;')}</span>
            <button class="pl-item-remove" onclick="event.stopPropagation();window.player._removeFromQueue(${i})">✕</button>
          </div>`,
      )
      .join('');
  }
  _jumpTo(index) {
    this.currentIndex = index;
    const item = this.queue[index];
    if (item) this._loadAndPlay(item);
  }
  _removeFromQueue(index) {
    this.queue.splice(index, 1);
    if (this.currentIndex >= this.queue.length) {
      this.currentIndex = this.queue.length - 1;
    }
    if (this.currentIndex === index) {
      if (this.queue.length > 0) {
        const item = this.queue[this.currentIndex];
        if (item) this._loadAndPlay(item);
      } else {
        const audio = this._getAudioElement();
        if (audio) {
          audio.pause();
          audio.src = '';
        }
        const titleEl = document.getElementById('playerTitle');
        if (titleEl) this._setTitleText('未在播放');
        this._show(); // 队列清空后折叠回迷你状态
        this._updatePlayBtn();
        if (typeof window.clearPlayerState === 'function') window.clearPlayerState();
      }
    } else if (index < this.currentIndex) {
      this.currentIndex--;
    }
    this._updateQueueUI();
  }
  playFile(id, title, idType, lyrics) {
    this.queue = [{ id, title, idType: idType || 'file', lyrics: lyrics || null }];
    this.currentIndex = 0;
    const item = this.queue[0];
    if (item) this._loadAndPlay(item);
    this._show();
    this._updateQueueUI();
  }
  addToQueue(id, title, idType, lyrics) {
    this.queue.push({ id, title, idType: idType || 'file', lyrics: lyrics || null });
    this._updateQueueUI();
    if (typeof window.savePlayerState === 'function') {
      window.savePlayerState(this, this._getAudioElement());
    }
    this._showToast('✅ 已加入播放队列', 'success');
  }
  addAndPlay(id, title, idType) {
    this.queue.push({ id, title, idType: idType || 'file' });
    this.currentIndex = this.queue.length - 1;
    const item = this.queue[this.currentIndex];
    if (item) this._loadAndPlay(item);
    this._show();
    this._updateQueueUI();
  }
  prev() {
    if (this.queue.length === 0) return;
    this.currentIndex = (this.currentIndex - 1 + this.queue.length) % this.queue.length;
    const item = this.queue[this.currentIndex];
    if (item) this._loadAndPlay(item);
  }
  togglePlay() {
    const audio = this._getAudioElement();
    const bar = document.getElementById('globalPlayer');
    if (!audio) return;
    if (audio.paused) {
      this._wasPlaying = true;
      if (audio.src && audio.src !== window.location.href) {
        audio.play().catch(() => console.warn('[player] togglePlay 恢复播放被拦截'));
      } else if (this.queue.length > 0) {
        const item = this.queue[this.currentIndex];
        if (item) this._loadAndPlay(item);
      } else if (this.mode === 'siteShuffle') {
        this._playRandomSiteTrack();
      }
      if ('mediaSession' in navigator) navigator.mediaSession.playbackState = 'playing';
    } else {
      this._wasPlaying = false;
      audio.pause();
      if (bar) bar.classList.remove('playing');
      if ('mediaSession' in navigator) navigator.mediaSession.playbackState = 'paused';
    }
    this._updatePlayBtn();
    if (typeof window.savePlayerState === 'function') {
      window.savePlayerState(this, audio);
    }
  }
  next() {
    if (this.mode === 'siteShuffle') {
      this._playRandomSiteTrack();
      return;
    }
    if (this.queue.length === 0) return;
    if (this.mode === 'loopOne') {
      // 单曲循环：重播当前曲目
      const item = this.queue[this.currentIndex];
      if (item) this._loadAndPlay(item);
      return;
    }
    if (this.mode === 'shuffle') {
      // 随机播放：队列多于一首时避免立即重播当前曲目
      if (this.queue.length > 1) {
        let nextIndex;
        do {
          nextIndex = Math.floor(Math.random() * this.queue.length);
        } while (nextIndex === this.currentIndex);
        this.currentIndex = nextIndex;
      }
      // 队列只有一首时维持当前曲目继续播放
    } else if (this.mode === 'loop') {
      // 列表循环：播完最后一首回到第一首继续
      this.currentIndex = (this.currentIndex + 1) % this.queue.length;
    } else {
      // 顺序播放（sequence）：播完最后一首停止
      this.currentIndex = (this.currentIndex + 1) % this.queue.length;
      if (this.currentIndex === 0) {
        const audio = this._getAudioElement();
        if (audio) audio.pause();
        this._wasPlaying = false;
        this._updatePlayBtn();
        return;
      }
    }
    const item = this.queue[this.currentIndex];
    if (item) this._loadAndPlay(item);
  }
  async _playRandomSiteTrack() {
    if (this._randomSiteLoading) return;
    this._randomSiteLoading = true;
    const current = this.queue[this.currentIndex];
    const exclude = current?.idType === 'hymn' && current.id ? `?exclude=${encodeURIComponent(current.id)}` : '';
    try {
      const response = await fetch(`${this._API}/api/random-audio${exclude}`);
      const data = await response.json();
      if (!response.ok || !data.id) throw new Error('random audio unavailable');
      this.queue = [{ id: data.id, title: data.title || '未知曲目', idType: 'hymn' }];
      this.currentIndex = 0;
      this._loadAndPlay(this.queue[0]);
      this._show();
      this._updateQueueUI();
    } catch (e) {
      this._showToast('暂时没有可播放的歌曲', 'error');
    } finally {
      this._randomSiteLoading = false;
    }
  }
  setMode(mode) {
    this.mode = mode;
    this._syncModeUI();
    if (typeof window.savePlayerState === 'function') {
      window.savePlayerState(this, this._getAudioElement());
    }
    if (this.mode === 'siteShuffle' && this.queue.length === 0) {
      this._playRandomSiteTrack();
    }
  }
  /** 同步模式下拉框 #playerMode 与当前 this.mode（跨页恢复后下拉框可能仍显示默认值） */
  _syncModeUI() {
    const sel = document.getElementById('playerMode');
    if (sel && sel.value !== this.mode) sel.value = this.mode;
  }
  togglePlaylist() {
    const modal = document.getElementById('playlistModal');
    if (!modal) return;
    this.playlistModalOpen = !this.playlistModalOpen;
    modal.classList.toggle('show', this.playlistModalOpen);
    localStorage.setItem('playlistModalOpen', String(this.playlistModalOpen));
    if (this.playlistModalOpen) this._loadPlaylists();
  }
  toggleCollapse() {
    const bar = document.getElementById('globalPlayer');
    if (!bar) return;
    bar.classList.toggle('collapsed');
    this._playerCollapsed = bar.classList.contains('collapsed');
    // 折叠时同时收起歌词面板，避免遮挡
    if (this._playerCollapsed && this._lyricsOpen) {
      const panel = document.getElementById('playerLyricsPanel');
      if (panel) panel.classList.remove('show');
      this._lyricsOpen = false;
      const btn = document.getElementById('playerLyricsBtn');
      if (btn) btn.classList.remove('active');
    }
    try {
      localStorage.setItem('player_collapsed', this._playerCollapsed ? '1' : '0');
    } catch (e) {}
  }
  loadPlaylistItems(playlistId, showToastIfEmpty = false) {
    const jwt = localStorage.getItem('jwt');
    if (!playlistId || !jwt) return;
    fetch(`${this._API}/api/playlists/${String(playlistId)}/items`, {
      headers: { Authorization: `Bearer ${jwt}` },
    })
      .then((r) => r.json())
      .then((data) => {
        const items = Array.isArray(data) ? data : [];
        if (items.length === 0) {
          this.queue = [];
          this.currentIndex = -1;
          this._updateQueueUI();
          if (showToastIfEmpty) this._showToast('该播放列表为空', 'info');
          return;
        }
        this.queue = items.map((item) => ({
          id: item.hymn_id,
          title: item.title || '未知曲目',
          idType: 'hymn',
        }));
        this.currentIndex = 0;
        const first = this.queue[0];
        if (first) this._loadAndPlay(first);
        this._updateQueueUI();
        this._show();
      })
      .catch(() => {
        if (showToastIfEmpty) this._showToast('加载播放列表失败', 'error');
      });
  }
  renamePlaylist(playlistId, currentName) {
    const jwt = localStorage.getItem('jwt');
    if (!jwt) {
      alert('请先登录');
      return;
    }
    if (!playlistId) {
      alert('请先选择一个播放列表');
      return;
    }
    const name = prompt('请输入新名称：', currentName);
    if (!name || !name.trim() || name.trim() === currentName) return;
    fetch(`${this._API}/api/playlists/${String(playlistId)}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${jwt}` },
      body: JSON.stringify({ name: name.trim() }),
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.success) {
          this._loadPlaylists();
        } else {
          alert(data.error || '重命名失败');
        }
      })
      .catch(() => alert('网络错误'));
  }
  createPlaylist() {
    const name = prompt('请输入播放列表名称：');
    if (!name || !name.trim()) return;
    const jwt = localStorage.getItem('jwt');
    if (!jwt) {
      alert('请先登录');
      return;
    }
    fetch(`${this._API}/api/playlists`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${jwt}` },
      body: JSON.stringify({ name: name.trim() }),
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.success) {
          this._loadPlaylists();
          setTimeout(() => {
            const sel = document.getElementById('plListSelect');
            if (sel) {
              sel.value = String(data.id);
              this.queue = [];
              this.currentIndex = -1;
              this._updateQueueUI();
            }
          }, 100);
        } else {
          alert(data.error || '创建失败');
        }
      })
      .catch(() => alert('网络错误'));
  }
  deletePlaylist(playlistId, name) {
    const jwt = localStorage.getItem('jwt');
    if (!jwt) {
      alert('请先登录');
      return;
    }
    if (!playlistId) {
      alert('请先选择一个播放列表');
      return;
    }
    if (!confirm(`确定要删除播放列表「${name}」吗？`)) return;
    fetch(`${this._API}/api/playlists/${String(playlistId)}`, {
      method: 'DELETE',
      headers: { Authorization: `Bearer ${jwt}` },
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.success) {
          const audio = this._getAudioElement();
          if (audio && !audio.paused && this.queue.length > 0) {
            audio.pause();
            this._updatePlayBtn();
          }
          this.queue = [];
          this.currentIndex = -1;
          if (audio) {
            audio.src = '';
            audio.currentTime = 0;
          }
          this._updateQueueUI();
          this._updatePlayBtn();
          this._loadPlaylists();
          this._showToast('✅ 播放列表已删除', 'success');
        } else {
          alert(data.error || '删除失败');
        }
      })
      .catch(() => alert('网络错误'));
  }
  /** 当前曲目播放到接近末尾时，预加载下一首 */
  _preloadNext() {
    const audio = this._getAudioElement();
    if (!audio || !audio.duration || !isFinite(audio.duration) || audio.duration === 0) return;
    // 剩余 < 10s 或进度 > 80%
    const remaining = audio.duration - audio.currentTime;
    if (remaining > 10 && audio.currentTime / audio.duration < 0.8) return;

    const nextIndex = this.currentIndex + 1;
    if (nextIndex >= this.queue.length) return;
    const nextItem = this.queue[nextIndex];
    if (!nextItem || !nextItem.id) return;

    // 使用 <link rel="preload"> 轻量预加载，不增加额外 DOM 开销
    const url = `${this._API}/api/download/${nextItem.idType === 'hymn' ? 'hymn' : 'file'}/${nextItem.id}`;
    const existing = document.querySelector(`link[rel="preload"][href="${CSS.escape(url)}"]`);
    if (existing) return;

    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'audio';
    link.href = url;
    // 播放下一首时自动清理 preload link
    link.setAttribute('data-preload', '1');
    document.head.appendChild(link);

    // 清理之前的 preload link（最多保留当前 + 下一首）
    const prevLinks = document.querySelectorAll('link[data-preload]');
    while (prevLinks.length > 1) {
      prevLinks[0].remove();
      prevLinks.length--;
    }
  }

  /* ─────────────────────────────────────────────
   * 音量控制（参考 APlayer 补齐）
   * ───────────────────────────────────────────── */
  /** 恢复上次保存的音量（localStorage），并应用到 audio 元素 */
  _restoreVolume() {
    try {
      const saved = parseFloat(localStorage.getItem('player_volume'));
      if (isFinite(saved) && saved >= 0 && saved <= 1) this.volume = saved;
      const muted = localStorage.getItem('player_muted');
      if (muted === '1') this.muted = true;
    } catch (e) {}
    const audio = this._getAudioElement();
    if (audio) {
      // 只依赖 muted 标志静音，保持 volume 原值，避免取消静音后无声
      audio.volume = this.volume;
      audio.muted = this.muted;
    }
    this._updateVolumeUI();
  }
  /** 设置音量（0~1），并持久化 */
  setVolume(v) {
    const vol = Math.max(0, Math.min(1, Number(v) || 0));
    this.volume = vol;
    this.muted = false;
    const audio = this._getAudioElement();
    if (audio) {
      audio.volume = vol;
      audio.muted = false;
    }
    try {
      localStorage.setItem('player_volume', String(vol));
      localStorage.setItem('player_muted', '0');
    } catch (e) {}
    this._updateVolumeUI();
  }
  /** 静音开关 */
  toggleMute() {
    this.muted = !this.muted;
    const audio = this._getAudioElement();
    if (audio) audio.muted = this.muted;
    try {
      localStorage.setItem('player_muted', this.muted ? '1' : '0');
    } catch (e) {}
    this._updateVolumeUI();
  }
  /** 同步音量滑块/静音按钮 UI（状态未变化时跳过 DOM 写入） */
  _updateVolumeUI() {
    const slider = document.getElementById('playerVolume');
    const btn = document.getElementById('playerMuteBtn');
    const icon = btn ? btn.querySelector('.vol-icon') : null;
    const mutedState = !!this.muted || this.volume === 0;
    if (slider) {
      const val = String(Math.round((this.muted ? 0 : this.volume) * 100));
      if (slider.value !== val) slider.value = val;
    }
    if (btn && btn.classList.contains('muted') !== mutedState) btn.classList.toggle('muted', mutedState);
    if (icon) {
      const markup = mutedState
        ? '<path d="M11 5L6 9H2v6h4l5 4V5z"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/>'
        : '<path d="M11 5L6 9H2v6h4l5 4V5z"/><path d="M15.54 8.46a5 5 0 0 1 0 7.07"/>';
      if (icon.innerHTML !== markup) icon.innerHTML = markup;
    }
  }

  /* ─────────────────────────────────────────────
   * 全局歌词面板（参考 APlayer lrcType 思路）
   * ───────────────────────────────────────────── */
  /** 开关歌词面板 */
  toggleLyrics() {
    const panel = document.getElementById('playerLyricsPanel');
    const btn = document.getElementById('playerLyricsBtn');
    if (!panel) return;
    this._lyricsOpen = !this._lyricsOpen;
    panel.classList.toggle('show', this._lyricsOpen);
    if (btn) btn.classList.toggle('active', this._lyricsOpen);
    if (this._lyricsOpen) {
      // 打开时（重新）加载当前曲目歌词并同步进度（覆盖 bfcache 恢复等未走 _loadAndPlay 的场景）
      this._loadLyrics(this.queue[this.currentIndex]);
      const audio = this._getAudioElement();
      if (audio) this._updateLyricUI(audio.currentTime);
    }
  }
  /** 加载当前曲目歌词：优先用 queue item 携带的 lyrics（详情页直传），否则按 idType 拉取 */
  async _loadLyrics(item) {
    // 请求序号：快速切歌时丢弃过期响应，避免上一首歌词覆盖当前
    const reqId = (this._lyricsReqId = (this._lyricsReqId || 0) + 1);
    const apply = (lyrics) => {
      if (reqId !== this._lyricsReqId) return; // 已切歌，丢弃
      this._lyrics = lyrics;
      this._lyricIndex = -1; // 重置高亮索引，避免残留上一首的高亮行
      if (this._lyricsOpen) this._renderLyrics();
    };
    if (!item) {
      apply([]);
      return;
    }
    // 队列条目已携带歌词（如 hymn 详情页 playFile 直传 lrcData）
    if (Array.isArray(item.lyrics) && item.lyrics.length > 0) {
      apply(item.lyrics.map((l) => ({ t: Number(l.t) || 0, l: String(l.l != null ? l.l : l) })));
      return;
    }
    // 非 hymn 类型（普通 file）无接口可查歌词
    if (item.idType !== 'hymn') {
      apply([]);
      return;
    }
    // hymn 类型：拉取详情接口
    try {
      const res = await fetch(`${this._API}/api/hymns/${item.id}`);
      if (!res.ok) throw new Error('bad status');
      const data = await res.json();
      let lyrics = [];
      if (data.lrc_content) {
        try {
          const lrc = JSON.parse(data.lrc_content);
          if (Array.isArray(lrc) && lrc.length) {
            lyrics = lrc.map((e) => ({ t: Number(e.t) || 0, l: String(e.l || '') }));
          }
        } catch (e) {}
      }
      if (!lyrics.length && data.text_content) {
        // 无时间轴：按行近似每 30s 一行
        lyrics = data.text_content
          .split('\n')
          .filter((l) => l.trim())
          .map((l, i) => ({ t: i * 30, l: l.trim() }));
      }
      apply(lyrics);
    } catch (e) {
      apply([]);
    }
  }
  /** 渲染歌词列表到面板 */
  _renderLyrics() {
    const list = document.getElementById('playerLyricsList');
    if (!list) return;
    if (!this._lyrics.length) {
      list.innerHTML = '<div class="player-lrc-empty">暂无歌词</div>';
      return;
    }
    list.innerHTML = this._lyrics
      .map(
        (ln, i) =>
          `<div class="player-lrc-line${i === this._lyricIndex ? ' active' : ''}" data-idx="${i}">${String(ln.l || '')
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')}</div>`,
      )
      .join('');
  }
  /** 时间同步高亮歌词（timeupdate 调用，仅面板打开且有歌词时生效） */
  _updateLyricUI(currentTime) {
    if (!this._lyricsOpen || !this._lyrics.length) return;
    const list = document.getElementById('playerLyricsList');
    if (!list) return;
    let idx = -1;
    for (let i = this._lyrics.length - 1; i >= 0; i--) {
      if (currentTime >= this._lyrics[i].t) {
        idx = i;
        break;
      }
    }
    if (idx === this._lyricIndex) return;
    this._lyricIndex = idx;
    Array.prototype.forEach.call(list.children, (el, i) => {
      el.classList.toggle('active', i === idx);
    });
    if (idx >= 0) {
      const active = list.children[idx];
      if (active && active.scrollIntoView) active.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  destroy() {
    const audio = this._getAudioElement();
    if (audio) this._cleanupEvents(audio);
    this._initialized = false;
  }
  _showToast(message, type = 'info') {
    if (typeof window.Utils?.showToast === 'function') {
      window.Utils.showToast(message, type === 'error' ? 'error' : type);
    }
  }
}
/* ── 全局实例（DOM 解析完成后自动初始化）── */
if (typeof window !== 'undefined') {
  window.player = new HymnPlayer();
  // defer 脚本执行时 DOM 已解析完毕，直接初始化
  window.player.init();
  window.addEventListener('beforeunload', () => {
    window.player.destroy();
  });
}

/* ─────────────────────────────────────────────
 * 视频播放增强（参考 DPlayer 补齐：倍速 / 播放进度记忆 / 视频快捷键）
 * 用法：window.enhanceVideo(videoEl, { progressKey: 'file-123' })
 * 由 hymn.js（内联视频 + 预览）与 index.js（预览）在创建 <video> 后调用
 * ───────────────────────────────────────────── */

/* ─────────────────────────────────────────────
 * 续播进度跨设备同步（存后端用户偏好 /api/user/progress）
 * localStorage 仍为即时读取源；网络同步全部 fire-and-forget，绝不阻塞播放。
 * 未登录（无 jwt）时自动跳过，退化为纯本地。
 * ───────────────────────────────────────────── */
let _serverProgressSyncInFlight = null;
function _progressApiBase() {
  return window.API_BASE || window.API || '';
}
function _hasJwt() {
  try {
    return !!localStorage.getItem('jwt');
  } catch (e) {
    return false;
  }
}
/** fire-and-forget PUT 单条进度（跟随 saveProgress 节流节奏：60s 兜底 + pause/pagehide 立即） */
function _syncProgressToServer(key, t, duration) {
  if (!_hasJwt() || !window.fetchAuth) return;
  window
    .fetchAuth(_progressApiBase() + '/api/user/progress', {
      method: 'PUT',
      keepalive: true, // pagehide 时也尽量发出
      headers: { 'Content-Type': 'application/json' },
      // updated_at 用客户端时钟毫秒，与服务端存储同一时钟域，跨设备比较才可靠
      body: JSON.stringify({ key: key, t: t, duration: duration, updated_at: Date.now() }),
    })
    .catch(function () {});
}
/** 启动时拉取服务器进度合并进 localStorage（服务器 updated_at 更新才覆盖），完成后回调 */
function _syncProgressFromServer(done) {
  if (!_hasJwt() || !window.fetchAuth) {
    if (done) done();
    return;
  }
  if (_serverProgressSyncInFlight) {
    if (done) _serverProgressSyncInFlight.then(done).catch(done);
    return;
  }
  const p = window
    .fetchAuth(_progressApiBase() + '/api/user/progress')
    .then(function (res) {
      return res.ok ? res.json() : null;
    })
    .then(function (data) {
      if (!data || !Array.isArray(data.progress)) return;
      data.progress.forEach(function (item) {
        if (!item || !item.progress_key) return;
        // 音频进度 key 以 audio- 开头 → audio_progress_ 前缀；其余为视频 → video_progress_ 前缀
        const key = item.progress_key;
        const isAudio = key.indexOf('audio-') === 0;
        const sk = (isAudio ? 'audio_progress_' : 'video_progress_') + (isAudio ? key.slice(6) : key);
        let local = null;
        try {
          local = JSON.parse(localStorage.getItem(sk));
        } catch (e) {}
        const serverTs = item.updated_at || 0; // 客户端时钟毫秒（与服务端存储同域）
        if (!local || serverTs > (local.updated_at || 0)) {
          try {
            localStorage.setItem(sk, JSON.stringify({ t: item.t, duration: item.duration, updated_at: serverTs }));
          } catch (e2) {}
        }
      });
    })
    .catch(function () {})
    .finally(function () {
      _serverProgressSyncInFlight = null;
    });
  _serverProgressSyncInFlight = p;
  if (done) p.then(done).catch(done);
}

window.enhanceVideo = function (video, opts) {
  if (!video || video.dataset.videoEnhanced) return;
  opts = opts || {};
  video.dataset.videoEnhanced = '1';
  const container = opts.container || video.parentElement;
  if (!container) return;
  // 确保容器有定位上下文，控件才能绝对定位
  if (getComputedStyle(container).position === 'static') container.classList.add('video-enhance-host');

  const SPEEDS = [0.5, 0.75, 1, 1.25, 1.5, 2];
  const progressKey = opts.progressKey || 'video';

  // ── 倍速恢复 ──
  try {
    const savedRate = parseFloat(localStorage.getItem('video_playback_rate'));
    if (SPEEDS.includes(savedRate)) video.playbackRate = savedRate;
  } catch (e) {}

  // ── 控件集群（右上角：倍速）──
  const cluster = document.createElement('div');
  cluster.className = 'video-enhance-cluster';

  const speedBtn = document.createElement('button');
  speedBtn.type = 'button';
  speedBtn.className = 'video-speed-btn';
  speedBtn.title = '播放速度';
  speedBtn.textContent = video.playbackRate + 'x';
  cluster.appendChild(speedBtn);

  const menu = document.createElement('div');
  menu.className = 'video-speed-menu';
  SPEEDS.forEach(function (rate) {
    const item = document.createElement('div');
    item.className = 'video-speed-item' + (rate === video.playbackRate ? ' active' : '');
    item.textContent = rate + 'x';
    item.addEventListener('click', function (ev) {
      ev.stopPropagation();
      video.playbackRate = rate;
      speedBtn.textContent = rate + 'x';
      try {
        localStorage.setItem('video_playback_rate', String(rate));
      } catch (e2) {}
      menu.querySelectorAll('.video-speed-item').forEach((el) => el.classList.toggle('active', el === item));
      menu.classList.remove('show');
      if (typeof window.Utils !== 'undefined' && typeof window.Utils.showToast === 'function') {
        window.Utils.showToast('倍速 ' + rate + 'x');
      }
    });
    menu.appendChild(item);
  });
  speedBtn.addEventListener('click', function (ev) {
    ev.stopPropagation();
    menu.classList.toggle('show');
  });

  // 点击页面其他区域关闭倍速菜单（只绑定一次）
  if (!window.__videoMenuCloseBound) {
    window.__videoMenuCloseBound = true;
    document.addEventListener('click', function () {
      document.querySelectorAll('.video-speed-menu.show').forEach((m) => m.classList.remove('show'));
    });
  }

  // 画中画不添加自定义按钮：浏览器原生 <video controls> 已提供 PiP 入口（播放时控制条内），
  // 自定义按钮与之重复，故只保留倍速菜单、续播记忆、快捷键这些原生没有的能力
  container.appendChild(cluster);
  // 菜单挂到视频容器上（而非 absolute 集群内），保证 top/right 相对视频容器定位
  container.appendChild(menu);

  // ── 播放进度记忆（localStorage，事件驱动保存：暂停/离开立即写，播放中每 60s 兜底）──
  const storeKey = 'video_progress_' + progressKey;
  let lastSave = 0;
  function saveProgress(force) {
    const now = Date.now();
    // 兜底节流仅对 timeupdate 生效（60s 一次）；pause/pagehide/destroy 传 force=true 始终立即写。
    // 必须用 force !== true 严格判断：force 为 true 时绕过节流，其余情况（含 Event 对象）走节流
    if (force !== true && now - lastSave < 60000) return;
    lastSave = now;
    if (!video.duration || !isFinite(video.duration)) return;
    try {
      localStorage.setItem(
        storeKey,
        JSON.stringify({ t: video.currentTime, duration: video.duration, updated_at: Date.now() }),
      );
    } catch (e) {}
    // 跨设备同步（fire-and-forget，跟随同一节流节奏：60s 兜底 + pause/pagehide 立即）
    _syncProgressToServer(progressKey, video.currentTime, video.duration);
  }
  function clearProgress() {
    try {
      // 写 t=0 哨兵而非 removeItem：避免飞行中的 GET 合并把旧进度重新写回
      //（哨兵 updated_at 是当前时间，服务端旧值不会覆盖；tryResume 见 t<5 自动忽略）
      localStorage.setItem(storeKey, JSON.stringify({ t: 0, duration: video.duration || 0, updated_at: Date.now() }));
    } catch (e) {}
    // 播完清除：同步 t=0 到服务端（其他设备拉取时会因 <5s 忽略，等效清除）
    _syncProgressToServer(progressKey, 0, video.duration || 0);
  }
  function fmtTime(sec) {
    sec = Math.floor(sec);
    const m = Math.floor(sec / 60);
    const s = sec % 60;
    return m + ':' + (s < 10 ? '0' : '') + s;
  }
  // force=true 绕过节流立即写：用于暂停 / 离开页面 / 预览销毁等确定性保存时机
  function forceSave() {
    saveProgress(true);
  }
  // 播放中兜底：timeupdate 每 60s 写一次（防止播放中直接关标签/崩溃丢进度）
  video.addEventListener('timeupdate', saveProgress);
  // 事件驱动：暂停 / 离开页面时立即保存（保证进度准确）
  video.addEventListener('pause', forceSave);
  window.addEventListener('pagehide', forceSave);
  // 暴露保存钩子：预览弹窗销毁 <video> 前可调用（绕过节流兜底，避免最后一次保存被跳过）
  video._saveVideoProgress = forceSave;

  // 继续观看提示条
  const chip = document.createElement('div');
  chip.className = 'video-resume-chip';
  chip.style.display = 'none';
  container.appendChild(chip);
  let chipTimer = null;
  let resumed = false;
  function hideChip() {
    chip.style.display = 'none';
    clearTimeout(chipTimer);
  }
  // 点击提示条：从头播放（与「自动续播」互斥，用户可一键回到开头）
  chip.addEventListener('click', function (ev) {
    ev.stopPropagation();
    resumed = true; // 用户显式选择从头播放，避免 loadedmetadata/canplay 二次续播
    video.currentTime = 0;
    video.play().catch(function () {});
    hideChip();
  });
  // 自动续播检查。loadedmetadata + canplay 双触发 + readyState 兜底：
  // enhanceVideo 可能因异步解析 file id 而晚于 loadedmetadata 才绑定监听器，
  // 双事件覆盖 + 已就绪时立即检查，确保续播不错过时机
  function tryResume() {
    try {
      const saved = JSON.parse(localStorage.getItem(storeKey));
      if (!saved || !isFinite(saved.t) || !video.duration || !isFinite(video.duration)) return;
      // 进度过短（<5s）或已接近结尾（剩 <10s）时忽略
      if (saved.t < 5 || saved.t > video.duration - 10) return;
      // 自动续播到上次位置（页面加载即自动播放的视频场景下最自然，参考 DPlayer 续播思路）
      if (!resumed) {
        resumed = true;
        video.currentTime = saved.t;
        // 提示条：点击可从头播放，数秒后自动消失。
        // 仅在真正触发续播时显示，避免用户点击“从头播放”后 loadedmetadata
        // 因错误重试 load() 再次触发时提示条重新出现
        chip.textContent = '⏯ 已续播至 ' + fmtTime(saved.t) + '，点击从头播放';
        chip.style.display = 'block';
        clearTimeout(chipTimer);
        chipTimer = setTimeout(hideChip, 8000);
      }
    } catch (e) {}
  }
  video.addEventListener('loadedmetadata', tryResume);
  video.addEventListener('canplay', tryResume);
  // enhanceVideo 异步绑定场景：视频已加载完成时立即尝试（此时 loadedmetadata 已错过）
  if (video.readyState >= 1) tryResume();
  video.addEventListener('ended', clearProgress);
  // 启动时跨设备合并：服务器有更新则覆盖本地；若当前视频尚未续播则再尝试一次
  _syncProgressFromServer(function () {
    // 预览已销毁（video 脱离 DOM）时放弃重试，避免在游离元素上续播
    if (!video.isConnected) return;
    if (!resumed && video.readyState >= 1) tryResume();
  });

  // ── 视频快捷键（点击视频聚焦后生效：空格/←→/↑↓/M/F）──
  video.setAttribute('tabindex', '0');
  video.addEventListener('click', function () {
    try {
      video.focus({ preventScroll: true });
    } catch (e) {
      video.focus();
    }
  });
  video.addEventListener('keydown', function (e) {
    if (e.key === ' ') {
      e.preventDefault();
      if (video.paused) video.play().catch(function () {});
      else video.pause();
    } else if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
      e.preventDefault();
      if (video.duration && isFinite(video.duration)) {
        const delta = e.key === 'ArrowRight' ? 5 : -5;
        video.currentTime = Math.max(0, Math.min(video.duration, video.currentTime + delta));
      }
    } else if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
      e.preventDefault();
      const v = Math.max(0, Math.min(1, (video.volume || 0) + (e.key === 'ArrowUp' ? 0.1 : -0.1)));
      video.volume = v;
      video.muted = v === 0;
    } else if (e.key === 'm' || e.key === 'M') {
      e.preventDefault();
      video.muted = !video.muted;
    } else if (e.key === 'f' || e.key === 'F') {
      e.preventDefault();
      if (document.fullscreenElement) document.exitFullscreen().catch(function () {});
      else if (video.requestFullscreen) video.requestFullscreen().catch(function () {});
    }
  });
};

/* ─────────────────────────────────────────────
 * 视频预览弹窗构建（index.js 首页 与 hymn.js 详情页 共用）
 * 用法：window.buildVideoPreview({
 *   container: 预览内容容器（#previewContent）,
 *   previewUrl: 视频流地址（含 ?preview=1）,
 *   mime: 视频 MIME 类型,
 *   getProgressKey: () => string 或 Promise<string>  // 续播进度 key，支持异步解析 file id
 * })
 * 职责：渲染 16:9 视频容器 + 播放/暂停状态图标 + 缓冲动画、暂停背景音频播放栏、
 *       智能自动播放（前台有声/后台静音 + 失败降级）、错误重试、点击取消静音、
 *       enhanceVideo 接入（倍速 / 续播记忆 / 快捷键）
 * ───────────────────────────────────────────── */
window.buildVideoPreview = function (opts) {
  opts = opts || {};
  var c = opts.container;
  if (!c) return;
  var previewUrl = opts.previewUrl || '';
  var mime = opts.mime || 'video/mp4';

  c.style.overflow = '';
  c.style.display = '';
  c.style.flexDirection = '';
  c.innerHTML =
    `<div style="width:100%;aspect-ratio:16/9;max-height:68vh;background:#000;border-radius:8px;overflow:hidden;position:relative;">` +
    `<video controls preload="metadata" playsinline` +
    `  style="width:100%;height:100%;object-fit:contain;background:#000;display:block;"` +
    `  poster="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 9'%3E%3Crect fill='%231a1a1a' width='16' height='9'/%3E%3C/svg%3E">` +
    `  <source src="${previewUrl}" type="${mime}">` +
    `  您的浏览器不支持视频播放` +
    `</video>` +
    `<div id="videoStateIcon" style="position:absolute;inset:0;display:flex;align-items:center;justify-content:center;pointer-events:none;opacity:0;transition:opacity 0.25s;z-index:5;">` +
    `  <div id="playIcon" style="width:64px;height:64px;border-radius:50%;background:rgba(0,0,0,0.55);backdrop-filter:blur(4px);color:white;display:flex;align-items:center;justify-content:center;">` +
    `    <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor"><polygon points="6,3 20,12 6,21"/></svg>` +
    `  </div>` +
    `  <div id="pauseIcon" style="width:64px;height:64px;border-radius:50%;background:rgba(0,0,0,0.55);backdrop-filter:blur(4px);color:white;display:flex;align-items:center;justify-content:center;">` +
    `    <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor"><rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/></svg>` +
    `  </div>` +
    `</div>` +
    `<div id="videoBuffering" style="position:absolute;inset:0;display:none;align-items:center;justify-content:center;pointer-events:none;z-index:4;">` +
    `  <div class="spin" style="width:32px;height:32px;border-color:rgba(255,255,255,0.25);border-top-color:white;border-width:3px;margin:0;"></div>` +
    `</div>` +
    `</div>`;

  // 打开视频预览时暂停背景音频播放栏（hymn 页可能用 hymnAudio，首页用 globalAudio）
  const audioEl = document.getElementById('hymnAudio') || document.getElementById('globalAudio');
  if (audioEl && !audioEl.paused) {
    window._previewPausedAudio = audioEl;
    audioEl.pause();
    if (typeof window.player !== 'undefined' && typeof window.player._updatePlayBtn === 'function') {
      window.player._updatePlayBtn();
    }
  }

  // 视频状态控制（智能自动播放）
  var isMobile = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  // 移动端移除自定义播放/暂停状态叠加图标（浏览器自带）
  if (isMobile) {
    var ico = c.querySelector('#videoStateIcon');
    if (ico) ico.remove();
  }

  setTimeout(function () {
    var video = c.querySelector('video');
    var stateIcon = isMobile ? null : c.querySelector('#videoStateIcon');
    var playIcon = isMobile ? null : c.querySelector('#playIcon');
    var pauseIcon = isMobile ? null : c.querySelector('#pauseIcon');
    var hideTimer = null;
    var autoPlayAttempted = false;

    if (!video) return;

    // 视频增强：倍速 / 播放进度记忆 / 视频快捷键（参考 DPlayer 补齐）
    // getProgressKey 支持同步字符串或异步 Promise（如首页先解析主文件 file id）
    if (typeof window.enhanceVideo === 'function') {
      var keyResult = typeof opts.getProgressKey === 'function' ? opts.getProgressKey() : opts.progressKey;
      if (keyResult && typeof keyResult.then === 'function') {
        keyResult.then(function (key) {
          // 异步解析期间预览可能已关闭，video 已脱离 DOM
          if (!video || !video.isConnected) return;
          window.enhanceVideo(video, { progressKey: key || 'video' });
        });
        // 防御：Promise 意外 reject 时兜底绑定（避免增强功能静默丢失）
        keyResult.catch(function () {
          if (video && video.isConnected) window.enhanceVideo(video, { progressKey: 'video' });
        });
      } else {
        window.enhanceVideo(video, { progressKey: keyResult || 'video' });
      }
    }

    var bufferingEl = c.querySelector('#videoBuffering');

    // 显示/隐藏缓冲旋转动画
    function showBuffering(show) {
      if (!bufferingEl) return;
      bufferingEl.style.display = show ? 'flex' : 'none';
    }

    // 缓冲开始时显示旋转
    video.addEventListener('waiting', function () {
      showBuffering(true);
    });

    // 缓冲结束/可以播放时隐藏旋转
    video.addEventListener('canplay', function () {
      showBuffering(false);
      // 如果初始自动播放因视频未加载而失败，缓冲完成后重试
      if (autoPlayAttempted && video.paused) {
        video.play().catch(function () {});
      }
    });
    video.addEventListener('playing', function () {
      showBuffering(false);
    });

    // 显示状态图标（移动端跳过，浏览器自带播放/暂停状态提示）
    function showStateIcon(isPlaying) {
      if (isMobile || !stateIcon || !playIcon || !pauseIcon) return;
      if (isPlaying) {
        playIcon.style.display = 'none';
        pauseIcon.style.display = 'block';
      } else {
        playIcon.style.display = 'block';
        pauseIcon.style.display = 'none';
      }
      stateIcon.style.opacity = '0.9';
      // 自动隐藏
      clearTimeout(hideTimer);
      hideTimer = setTimeout(function () {
        stateIcon.style.opacity = '0';
      }, 600);
    }

    // 尝试自动播放（智能策略）
    var isVisible = document.visibilityState === 'visible';
    function autoPlay() {
      if (autoPlayAttempted) return;
      autoPlayAttempted = true;

      // 前台标签页：尝试有声播放
      if (isVisible) {
        video.muted = false;
        video
          .play()
          .then(function () {
            showStateIcon(true);
          })
          .catch(function (err) {
            console.warn('有声播放被阻止:', err);
            // 桌面端降级为静音播放
            if (!isMobile) {
              video.muted = true;
              video
                .play()
                .then(function () {
                  showStateIcon(true);
                })
                .catch(function (err2) {
                  console.warn('静音播放也失败:', err2);
                });
            }
          });
      } else {
        // 后台标签页：静音播放
        video.muted = true;
        video.play().catch(function (err) {
          console.warn('后台播放失败:', err);
        });
      }
    }

    // 监听标签页可见性变化（移除旧监听，避免多次打开预览时监听器累积）
    if (window._previewVisibilityHandler) {
      document.removeEventListener('visibilitychange', window._previewVisibilityHandler);
    }
    window._previewVisibilityHandler = function () {
      if (document.visibilityState === 'visible' && video.paused && !autoPlayAttempted) {
        // 从后台切换到前台，自动恢复有声播放
        autoPlay();
      }
    };
    document.addEventListener('visibilitychange', window._previewVisibilityHandler);

    // 首次自动播放
    autoPlay();

    // 播放事件
    video.addEventListener('play', function () {
      showStateIcon(true);
    });

    // 暂停事件
    video.addEventListener('pause', function () {
      showStateIcon(false);
    });

    // 错误处理
    video.addEventListener('error', function (e) {
      console.warn('视频播放错误:', e);
      showBuffering(false);
      video.addEventListener(
        'click',
        function () {
          video.load();
          video.play();
        },
        { once: true },
      );
    });

    // 点击取消静音
    video.addEventListener('click', function (e) {
      if (e.target !== video) return;
      if (video.muted) {
        video.muted = false;
      }
      showStateIcon(video.paused);
    });
  }, 100);
};

/* ── 统一销毁预览视频（暂停 + 保存进度 + 清空 innerHTML，彻底销毁 video 元素与监听器）── */
window.destroyVideoPreview = function () {
  var pc = document.getElementById('previewContent');
  if (!pc) return;
  pc.style.overflow = '';
  pc.style.display = '';
  pc.style.flexDirection = '';
  var pv = pc.querySelector('video');
  if (pv) {
    pv.pause();
    if (typeof pv._saveVideoProgress === 'function') pv._saveVideoProgress();
  }
  // 移除预览专用的 visibilitychange 监听器（避免 close 后残留指向已脱离 DOM video 的闭包）
  if (window._previewVisibilityHandler) {
    document.removeEventListener('visibilitychange', window._previewVisibilityHandler);
    window._previewVisibilityHandler = null;
  }
  // 清除 previewContent 内容，彻底销毁 video/audio 元素及其事件监听
  // 防止 canplay 等事件在 pause() 后重新触发 play()
  pc.innerHTML = '';
};

/* ── PWA 安装提示 ── */
(function () {
  let deferredPrompt = null;
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredPrompt = e;
    // 在全局播放栏右侧添加安装按钮
    const bar = document.getElementById('globalPlayer');
    if (!bar) return;
    // 避免重复添加
    if (document.getElementById('pwaInstallBtn')) return;
    const btn = document.createElement('button');
    btn.id = 'pwaInstallBtn';
    btn.title = '安装到桌面';
    btn.style.cssText =
      'background:none;border:none;color:var(--text,#ccc);cursor:pointer;padding:0 0.35rem;display:flex;align-items:center;opacity:0.7;transition:opacity 0.2s;font-size:0.85rem;' +
      'flex-shrink:0;';
    btn.innerHTML =
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>';
    btn.onclick = async () => {
      if (!deferredPrompt) return;
      deferredPrompt.prompt();
      const result = await deferredPrompt.userChoice;
      if (result.outcome === 'accepted') {
        btn.remove();
      }
      deferredPrompt = null;
    };
    const controls = bar.querySelector('.player-controls') || bar.querySelector('.player-left');
    if (controls) {
      controls.parentNode.insertBefore(btn, controls.nextSibling);
    } else {
      // fallback: 追加到末尾
      const titleEl = document.getElementById('playerTitle');
      if (titleEl && titleEl.parentNode) {
        titleEl.parentNode.insertBefore(btn, titleEl.nextSibling);
      }
    }
  });
  // 已安装则不再显示
  window.addEventListener('appinstalled', () => {
    deferredPrompt = null;
    const btn = document.getElementById('pwaInstallBtn');
    if (btn) btn.remove();
  });
})();
//# sourceMappingURL=player.js.map

'use strict';
/**
 * cache-db.js — IndexedDB 持久缓存模块
 * 用于首页 API 响应数据（目录、统计、热门、最新）的本地缓存。
 * 缓存优先 + 后台刷新的策略，让回访用户秒开首页。
 *
 * 依赖：无（纯原生 IndexedDB）
 *
 * 使用方式：
 *   const data = await CacheDB.get('folders');
 *   if (data) renderFromCache(data);
 *   CacheDB.fetchAndCache('/api/folders', 'folders', 300).then(renderFromFresh);
 */

const CacheDB = (function () {
  const DB_NAME = 'hymns_cache_v1';
  const STORE_NAME = 'api_cache';
  const DB_VERSION = 1;

  /** 打开数据库连接 */
  function _openDB() {
    return new Promise(function (resolve, reject) {
      if (!window.indexedDB) {
        reject(new Error('IndexedDB 不可用'));
        return;
      }
      var request = indexedDB.open(DB_NAME, DB_VERSION);
      request.onupgradeneeded = function (e) {
        var db = e.target.result;
        if (!db.objectStoreNames.contains(STORE_NAME)) {
          var store = db.createObjectStore(STORE_NAME, { keyPath: 'key' });
          store.createIndex('timestamp', 'timestamp', { unique: false });
        }
      };
      request.onsuccess = function (e) {
        resolve(e.target.result);
      };
      request.onerror = function () {
        reject(new Error('IndexedDB 打开失败'));
      };
    });
  }

  /**
   * 从缓存中读取数据
   * @param {string} key - 缓存键
   * @returns {Promise<*|null>} 缓存命中且未过期返回数据，否则返回 null
   */
  async function get(key) {
    try {
      var db = await _openDB();
      return new Promise(function (resolve) {
        var tx = db.transaction(STORE_NAME, 'readonly');
        var store = tx.objectStore(STORE_NAME);
        var request = store.get(key);
        request.onsuccess = function () {
          var record = request.result;
          if (!record) {
            resolve(null);
            return;
          }
          // 检查 TTL
          if (Date.now() - record.timestamp > record.ttl * 1000) {
            // 过期，异步删除（不阻塞）
            _delete(key).catch(function () {});
            resolve(null);
            return;
          }
          resolve(record.data);
        };
        request.onerror = function () {
          resolve(null);
        };
        tx.oncomplete = function () {
          db.close();
        };
      });
    } catch (e) {
      return null;
    }
  }

  /**
   * 写入缓存
   * @param {string} key - 缓存键
   * @param {*} data - 要缓存的数据
   * @param {number} ttl - 有效期（秒）
   */
  async function set(key, data, ttl) {
    try {
      var db = await _openDB();
      return new Promise(function (resolve) {
        var tx = db.transaction(STORE_NAME, 'readwrite');
        var store = tx.objectStore(STORE_NAME);
        store.put({ key: key, data: data, timestamp: Date.now(), ttl: ttl });
        tx.oncomplete = function () {
          db.close();
          resolve();
        };
        tx.onerror = function () {
          db.close();
          resolve();
        };
      });
    } catch (e) {
      // 静默失败
    }
  }

  /** 删除单条缓存 */
  async function _delete(key) {
    try {
      var db = await _openDB();
      return new Promise(function (resolve) {
        var tx = db.transaction(STORE_NAME, 'readwrite');
        var store = tx.objectStore(STORE_NAME);
        store.delete(key);
        tx.oncomplete = function () {
          db.close();
          resolve();
        };
        tx.onerror = function () {
          db.close();
          resolve();
        };
      });
    } catch (e) {}
  }

  /**
   * 按前缀删除缓存（用于数据变更后失效）
   * @param {string} prefix - 键前缀，如 'recent_'
   */
  async function invalidateByPrefix(prefix) {
    try {
      var db = await _openDB();
      return new Promise(function (resolve) {
        var tx = db.transaction(STORE_NAME, 'readwrite');
        var store = tx.objectStore(STORE_NAME);
        var request = store.openCursor();
        request.onsuccess = function (e) {
          var cursor = e.target.result;
          if (cursor) {
            if (cursor.key.indexOf(prefix) === 0) {
              cursor.delete();
            }
            cursor.continue();
          } else {
            resolve();
          }
        };
        request.onerror = function () {
          resolve();
        };
        tx.oncomplete = function () {
          db.close();
        };
      });
    } catch (e) {}
  }

  /**
   * 清空所有缓存
   */
  async function clearAll() {
    try {
      var db = await _openDB();
      return new Promise(function (resolve) {
        var tx = db.transaction(STORE_NAME, 'readwrite');
        var store = tx.objectStore(STORE_NAME);
        store.clear();
        tx.oncomplete = function () {
          db.close();
          resolve();
        };
        tx.onerror = function () {
          db.close();
          resolve();
        };
      });
    } catch (e) {}
  }

  /**
   * 高阶函数：缓存优先，同时发起网络请求更新
   * 先 resolve 缓存数据（如有），网络请求完成后更新缓存并 resolve 新数据
   *
   * @param {string} cacheKey - 缓存键
   * @param {Function} fetchFn - 返回 Promise<data> 的网络请求函数
   * @param {number} ttl - 缓存 TTL（秒）
   * @param {Function} [renderFn] - 渲染回调，收到 (data, fromCache) 两个参数
   * @returns {Promise<*>} 最终返回网络最新数据
   */
  async function withCache(cacheKey, fetchFn, ttl, renderFn) {
    // 1. 先尝试从缓存读取并渲染
    var cached = await get(cacheKey);
    if (cached && typeof renderFn === 'function') {
      // 异步执行，不阻塞后续网络请求
      setTimeout(function () {
        renderFn(cached, true);
      }, 0);
    }

    // 2. 始终发起网络请求获取最新数据
    try {
      var fresh = await fetchFn();
      // 写入缓存
      await set(cacheKey, fresh, ttl);
      // 渲染新数据
      if (typeof renderFn === 'function') {
        renderFn(fresh, false);
      }
      return fresh;
    } catch (e) {
      // 网络失败时，如果有缓存数据则无需处理（已渲染）
      // 无缓存时抛出错误让调用方处理
      if (!cached) throw e;
      return cached;
    }
  }

  // 公开 API
  return {
    get: get,
    set: set,
    invalidateByPrefix: invalidateByPrefix,
    clearAll: clearAll,
    withCache: withCache,
  };
})();

/* ── 导出到全局 ── */
if (typeof window !== 'undefined') {
  window.CacheDB = CacheDB;
}

'use strict';
/**
 * offline.js — 离线播放模块
 * 通过 postMessage 与 Service Worker 通信，管理音频文件的本地缓存。
 * 用户可以将音频「缓存到本地」，断网后仍能播放。
 *
 * 依赖：config.js (API_BASE)
 * 必须在 SW 注册后加载（建议 defer 且在 sw.js 注册之后）
 */

const OFFLINE = {
  _swReady: false,
  _listeners: new Map(),
  _pendingChecks: new Map(), // url -> { resolve, reject }

  /** 初始化：监听 SW 的 message 事件 */
  init() {
    if (!('serviceWorker' in navigator)) return;
    const self = this;

    // 监听来自 SW 的响应消息
    navigator.serviceWorker.addEventListener('message', (event) => {
      const data = event.data;
      if (!data || !data.type) return;

      switch (data.type) {
        case 'CACHE_RESULT':
          self._resolvePending(data.url, { success: data.success, error: data.error });
          self._notify('cacheResult', { hymnId: data.hymnId, url: data.url, success: data.success });
          break;
        case 'CHECK_RESULT':
          self._resolvePending(data.url, { cached: data.cached });
          break;
        case 'DELETE_RESULT':
          self._resolvePending(data.url, { success: true });
          self._notify('deleteResult', { hymnId: data.hymnId, url: data.url });
          break;
        case 'LIST_RESULT':
          self._resolvePending('__list__', { urls: data.urls });
          break;
      }
    });

    // 检查 SW 是否已激活
    if (navigator.serviceWorker.controller) {
      this._swReady = true;
    } else {
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        this._swReady = true;
      });
    }
  },

  /** 内部：等待 SW 准备就绪 */
  _waitForSW() {
    return new Promise((resolve) => {
      if (this._swReady) return resolve();
      const check = () => {
        if (navigator.serviceWorker.controller) {
          this._swReady = true;
          resolve();
        } else {
          setTimeout(check, 200);
        }
      };
      check();
    });
  },

  /** 内部：发送消息到 SW */
  _send(data) {
    if (!navigator.serviceWorker.controller) return;
    navigator.serviceWorker.controller.postMessage(data);
  },

  /** 内部：创建待处理 Promise */
  _createPending(key) {
    return new Promise((resolve, reject) => {
      this._pendingChecks.set(key, { resolve, reject });
      // 30 秒超时
      setTimeout(() => {
        if (this._pendingChecks.has(key)) {
          this._pendingChecks.get(key).reject(new Error('Timeout'));
          this._pendingChecks.delete(key);
        }
      }, 30000);
    });
  },

  /** 内部：完成待处理 Promise */
  _resolvePending(key, value) {
    if (this._pendingChecks.has(key)) {
      this._pendingChecks.get(key).resolve(value);
      this._pendingChecks.delete(key);
    }
  },

  /** 内部：通知监听器 */
  _notify(event, data) {
    const handlers = this._listeners.get(event);
    if (handlers) {
      handlers.forEach((fn) => fn(data));
    }
  },

  /** 监听事件：cacheResult, deleteResult */
  on(event, fn) {
    if (!this._listeners.has(event)) this._listeners.set(event, []);
    this._listeners.get(event).push(fn);
  },

  /** 取消监听 */
  off(event, fn) {
    const handlers = this._listeners.get(event);
    if (handlers) {
      this._listeners.set(
        event,
        handlers.filter((h) => h !== fn),
      );
    }
  },

  /**
   * 缓存音频文件到 SW 的 MEDIA_CACHE
   * @param {number} hymnId
   * @param {object} [options]
   * @param {function} [options.onProgress] - 进度回调 (暂时不支持真实进度，仅通知开始/完成)
   * @returns {Promise<{success: boolean, error?: string}>}
   */
  async cacheAudio(hymnId, options = {}) {
    await this._waitForSW();
    const url = `${window.API_BASE || ''}/api/download/${hymnId}`;
    const key = url;

    const promise = this._createPending(key);
    this._send({ type: 'CACHE_AUDIO', url, hymnId });

    if (options.onProgress) options.onProgress({ status: 'started', hymnId });
    try {
      const result = await promise;
      if (options.onProgress && result.success) options.onProgress({ status: 'done', hymnId });
      else if (options.onProgress) options.onProgress({ status: 'error', hymnId, error: result.error });
      return result;
    } catch (e) {
      if (options.onProgress) options.onProgress({ status: 'error', hymnId, error: e.message });
      return { success: false, error: e.message };
    }
  },

  /**
   * 检查音频是否已缓存
   * @param {number} hymnId
   * @returns {Promise<boolean>}
   */
  async isCached(hymnId) {
    await this._waitForSW();
    const url = `${window.API_BASE || ''}/api/download/${hymnId}`;
    const key = url;

    const promise = this._createPending(key);
    this._send({ type: 'CHECK_CACHED', url, hymnId });

    try {
      const result = await promise;
      return !!result.cached;
    } catch (e) {
      return false;
    }
  },

  /**
   * 删除缓存的音频
   * @param {number} hymnId
   * @returns {Promise<boolean>}
   */
  async removeCached(hymnId) {
    await this._waitForSW();
    const url = `${window.API_BASE || ''}/api/download/${hymnId}`;
    const key = url;

    const promise = this._createPending(key);
    this._send({ type: 'DELETE_CACHED', url, hymnId });

    try {
      const result = await promise;
      return !!result.success;
    } catch (e) {
      return false;
    }
  },

  /**
   * 获取所有已缓存的音频 URL 列表
   * @returns {Promise<string[]>}
   */
  async listCached() {
    await this._waitForSW();
    const promise = this._createPending('__list__');
    this._send({ type: 'LIST_CACHED' });

    try {
      const result = await promise;
      return result.urls || [];
    } catch (e) {
      return [];
    }
  },

  /**
   * 从 URL 中提取 hymn ID
   * @param {string} url
   * @returns {number|null}
   */
  _extractId(url) {
    const match = url.match(/\/api\/download\/(\d+)/);
    return match ? parseInt(match[1], 10) : null;
  },

  /**
   * 获取所有已缓存的音频 ID 列表
   * @returns {Promise<number[]>}
   */
  async getCachedIds() {
    const urls = await this.listCached();
    const ids = urls.map((u) => this._extractId(u)).filter(Boolean);
    return [...new Set(ids)];
  },

  /**
   * 获取已缓存的总大小（字节）
   * 注意：此功能需要额外的 SW 支持，暂时返回 0
   * @returns {Promise<number>}
   */
  async getCacheSize() {
    const urls = await this.listCached();
    return urls.length;
  },
};

/* ── 导出到全局 ── */
if (typeof window !== 'undefined') {
  window.OFFLINE = OFFLINE;
}

/* ── 自动初始化 ── */
if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    OFFLINE.init();
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      OFFLINE.init();
    });
  }
}

/**
 * UI/UX 修复补丁
 *
 * 修复内容:
 * 1. Modal 键盘导航（ESC 关闭所有弹窗）
 * 2. ARIA 标签添加
 */

// 修复 1: Modal 键盘导航（ESC 关闭）
function initModalKeyboard() {
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      // 关闭所有弹窗（覆盖 modal-overlay、dn-modal-overlay、mf-modal-backdrop、mf-overlay、settings-sidebar-overlay 等）
      document
        .querySelectorAll('[class*="overlay"].show, [class*="modal-backdrop"].show, .mf-modal.show')
        .forEach((el) => {
          el.classList.remove('show');
        });
    }
  });
}

// 修复 2: ARIA 标签
function initAriaLabels() {
  // Logo 链接
  const logo = document.querySelector('.logo-wrap');
  if (logo && !logo.getAttribute('aria-label')) {
    logo.setAttribute('aria-label', '赞美诗资料库 - 返回首页');
  }

  // FAB 按钮
  const fab = document.getElementById('fabToTop');
  if (fab && !fab.getAttribute('aria-label')) {
    fab.setAttribute('aria-label', '返回顶部');
  }

  // 装饰性 SVG
  document.querySelectorAll('.empty-icon svg, .icon-only svg').forEach((svg) => {
    svg.setAttribute('aria-hidden', 'true');
  });
}

// ════════════════════════════════════════
// SW 更新消息监听（controllerchange 事件的主要防御）
// ════════════════════════════════════════
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data && event.data.type === 'SW_UPDATED') {
      if (window._swRefreshing) return;
      window._swRefreshing = true;
      window.location.reload();
    }
  });
}

// 初始化
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initModalKeyboard();
    initAriaLabels();
  });
} else {
  initModalKeyboard();
  initAriaLabels();
}
